<template>
  <div id="taskDetails">
    <v-container class="pa-0">
      <v-layout>
          <v-flex class="xs12 sm12 mb-5">
              <v-btn fab absolute left :to="{ path: '/admin/families'}" class="ml-3 pf-btn-fab">
                  <v-icon>arrow_back</v-icon>
              </v-btn>
              <v-btn absolute right v-if="!editMode" @click="addNote" class="ml-3 pf-btn-fab">
                <!-- <v-icon>add</v-icon> -->
                Add Note
              </v-btn>
          </v-flex>
      </v-layout>
    </v-container>

    <v-container class="px-0">

      <v-tabs
        v-model="tabsModel"
        slider-color="#019d8c"
        class="pf-tabs-teal-sm pf-tab"
        @change="{}"
      >
        <v-tab href="#tab-1">Account</v-tab>
        <v-tab href="#tab-2">Organizations</v-tab>
        <v-tab href="#tab-3">Production Info</v-tab>
        <v-tab href="#tab-4">Profile URLs</v-tab>
        <v-tab href="#tab-5">Notes</v-tab>
        <v-tab href="#tab-6">Surveys</v-tab>
        <v-tab href="#tab-7">Print</v-tab>
        <!-- <v-tab href="#tab-7">Emails</v-tab> -->

        <!-- Account information -->
        <v-tab-item value="tab-1">
          <v-layout>
            <v-form ref="accountInfoForm">
              <v-layout wrap>
                <v-flex xs12 sm12 class="pl-2">
                  <h5 class="text-uppercase font-weight-bold mb-3">Account Information</h5>
                </v-flex>
                <v-flex xs12 class="my-3 pr-4 pl-4">
                  <div class="mt-0 left pr-3 switch-account">
                    <v-label class="required">Account Type</v-label>
                  </div>
                  <div class="pt-1">  
                     <label class="switch-cover">
                      <input type="radio" v-model="accountObj.account_type" name="radio" id="couple" value="Couple" @change="changeAccountType($event.target.value)">
                      <span class="checkmark">Couple</span>
                    </label>
                    <label class="switch-cover">
                      <input type="radio" v-model="accountObj.account_type" id="single" name="radio" value="Single" @change="changeAccountType($event.target.value)">
                      <span class="checkmark">Single</span>
                    </label>
                  </div>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model.trim="accountObj.human[0].first_name" :rules="[v => !!v || 'Firstname is required']" label="Parent 1 first name"
                  class="required pr-4 pl-4" @change="isAccountInfoChanged = true"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="accountObj.human[0].last_name" label="Parent 1 last name" class="pr-4 pl-4" @change="isAccountInfoChanged = true"></v-text-field>
                </v-flex>
                <template v-if="accountObj.account_type === 'Couple' && accountObj.human.length > 1">
                  <v-flex xs12 sm6>
                    <v-text-field v-model.trim="accountObj.human[1].first_name" :rules="[v => !!v || 'Firstname is required']" label="Parent 2 first name"
                    class="required pr-4 pl-4" @change="isAccountInfoChanged = true"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="accountObj.human[1].last_name" label="Parent 2 last name" class="pr-4 pl-4" @change="isAccountInfoChanged = true"></v-text-field>
                  </v-flex>
                </template>
                <v-flex xs12 sm6>
                  <v-menu
                    v-model="joinedDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formatDateString(accountObj.joined_date, 'MM/DD/YYYY')"
                        readonly
                        v-on="on"
                        prepend-icon="event"
                        label="Joined date"
                        :rules="[v => !!v || 'Joined date is required']"
                        class="required pr-4 pl-4"
                      ></v-text-field>
                    </template>
                    <v-date-picker color="#019d8c" :max="new Date().toISOString().substr(0, 10)" :value="accountObj.joined_date ? accountObj.joined_date.substr(0, 10) : ''" @input="changeJoinDate($event)"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select v-model="accountObj.membership" :rules="[v => !!v || 'Membership level is required']" label="Membership level" class="required pr-4 pl-4" :items="['Network', 'Featured', 'Preferred']" @change="isAccountInfoChanged = true"></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field disabled v-model.trim="accountObj.human[0].user.username" label="Username"
                  class="required pr-4 pl-4" :rules="[v => !!v || 'Username is required']" @change="isAccountInfoChanged = true"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select v-model="accountObj.profile_status" label="Profile status" class="pr-4 pl-4" :items="profileStatusList" @change="isAccountInfoChanged = true" multiple attach small-chips deletable-chips></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field disabled v-model="accountObj.ppn" label="PPN" :rules="[v => !!v || 'PPN can\'t be blank']" class="required pr-4 pl-4" @change="isAccountInfoChanged = true"></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 sm6>
                  <v-autocomplete
                    v-model="accountObj.reporting_to"
                    label="Reporting to"
                    class="pr-4 pl-4"
                    :items="AgencyList"
                    item-text="name"
                    item-value="id"
                    @change="isAccountInfoChanged = true">
                  </v-autocomplete>
                </v-flex> -->
                <v-flex xs12 class="pr-0 pl-4">
                  <div class="d-inline-flex">
                    <v-btn :disabled="!isAccountInfoChanged" class="mx-0 my-2 pf-btn pf-btn-save" @click="saveAccountInfo">
                      <v-icon size="16" class="pr-1">check_circle</v-icon>
                      <div>Save</div>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-layout>

          <!-- Contact information -->
          <v-layout class="mt-5">
            <v-form ref="contactForm">
              <v-layout wrap>
                <v-flex xs12 sm12 class="pl-2">
                  <h5 class="text-uppercase font-weight-bold mb-3">Contact Information</h5>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="accountObj.contactInfo.email" @blur="duplicateEmailChecking(false)" label="Email address" :rules="rules.email" class="required pr-4 pl-4" @change="isContactInfoChanged = true"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-mask="'(###) ###-####'" v-model.trim="accountObj.contactInfo.phone" :rules="rules.phone" label="Phone number"
                  class="required pr-4 pl-4" @change="isContactInfoChanged = true"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="accountObj.email" @blur="duplicateEmailChecking(true)" label="Secondary email" :rules="[]" class="pr-4 pl-4" @change="isContactInfoChanged = true"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-mask="'(###) ###-####'" v-model.trim="accountObj.phone" :rules="[]" label="Secondary phone"
                  class="pr-4 pl-4" @change="isContactInfoChanged = true"></v-text-field>
                </v-flex>
                <v-flex xs12 class="pr-0 pl-4">
                  <div class="d-inline-flex">
                    <v-btn :disabled="!isContactInfoChanged" class="mx-0 my-2 pf-btn pf-btn-save" @click="saveContactInfo">
                      <v-icon size="16" class="pr-1">check_circle</v-icon>
                      <div>Save</div>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-layout>

          <!-- Writer & Designer -->
          <v-layout class="mt-5">
            <v-form ref="writerDesignerForm">
              <v-layout wrap>
                <v-flex xs12 sm12 class="pl-2">
                  <h5 class="text-uppercase font-weight-bold mb-3">Writer & Designer</h5>
                </v-flex>
                <v-flex class="py-2">
                  <v-select
                    v-model="profileDocument.writer"
                    label="Writing coach is"
                    :items="writersList"
                    item-text="name"
                    item-value="id"
                    class="pr-3 pl-3"
                    @change="updateProfileDocument"
                  >
                  </v-select>
                </v-flex>
                <v-flex class="py-2">
                  <v-select
                    v-model="profileDocument.designer"
                    label="Designer is"
                    :items="designersList"
                    item-text="name"
                    item-value="id"
                    class="pr-3 pl-3"
                    @change="updateProfileDocument"
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-layout>

          <!-- Task Information -->
          <v-layout class="mt-5">
            <v-layout wrap>
              <v-flex xs12 sm12 class="pl-2">
                <h5 class="text-uppercase font-weight-bold mb-3">Task Information</h5>
              </v-flex>
              <v-flex class="py-2 px-4">
                <table class="pf-simple-table white-table">
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Total</td>
                      <td>{{ accountObj.task.length || '0' }}</td>
                    </tr>
                    <tr v-if="accountObj.task.length">
                      <td>Open</td>
                      <td>{{ accountObj.task.filter(x => x.status === 'Open').length }}</td>
                    </tr>
                    <tr v-if="accountObj.task.length">
                      <td>In-Progress</td>
                      <td>{{ accountObj.task.filter(x => x.status === 'In-Progress').length }}</td>
                    </tr>
                    <tr v-if="accountObj.task.length">
                      <td>Closed</td>
                      <td>{{ accountObj.task.filter(x => x.status === 'Closed').length }}</td>
                    </tr>
                  </tbody>
                </table>
              </v-flex>              
            </v-layout>
          </v-layout>

        </v-tab-item>

        <!-- Organizations -->
        <v-tab-item value="tab-2">
          <v-layout wrap class="mt-2">
            <v-flex xs12 sm12 class="pl-2">
              <h5 class="text-uppercase font-weight-bold mb-3">Organizations</h5>
            </v-flex>
            <v-flex class="pl-4 pr-4">
              <table class="pf-simple-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <!-- <th>Contact</th> -->
                    <th>Status</th>
                    <th>PF Site Agency</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(agency, a) in accountObj.agency" :key="a">
                    <template v-if="!agency || !agency.agency">
                      <td colspan="3">No agencies found</td>
                    </template>
                    <template v-else>
                      <td>{{ a + 1 }}</td>
                      <td>{{ agency.agency.name || '--' }}</td>
                      <!-- <td>{{ 'Rafeeque' }}</td> -->
                      <!-- <td>{{ agency.status || '--' }}</td> -->
                      <td width="180">
                        <v-layout justify-center>
                          <v-select
                            v-model="agency.status"
                            :items="statusList"
                            height="30px"
                            @change="updateAccountStatus($event, agency.agency)"
                            class="py-0"
                          ></v-select>
                        </v-layout>
                      </td>
                      <td>{{ accountObj.default_agency && accountObj.default_agency.id && accountObj.default_agency.id.toString() === agency.agency.id.toString() ? 'Yes' : 'No' }}</td>
                      <td>
                        <v-btn icon class="ma-0" v-if="accountObj.default_agency.id.toString() !== agency.agency.id.toString() && activeStatuses.indexOf(agency.status) !== -1" @click="setDefaultContact(agency.agency)" title="Set PF site agency">
                          <v-icon size="22" color="grey darken-2">contact_phone</v-icon>
                        </v-btn> 
                        <v-btn icon class="ma-0" @click="removeRequest(agency)" :disabled="accountObj.default_agency && accountObj.default_agency.id === agency.agency.id" title="Remove">
                          <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                        </v-btn>
                      </td>
                    </template>
                  </tr>
                </tbody>
              </table>
              <v-flex>
                <div class="d-inline-flex">
                  <v-btn class="mx-0 my-2 pf-btn pf-btn-save" @click="addNewAgency">
                    <v-icon size="16" class="pr-1">add</v-icon>
                    <div>Add New</div>
                  </v-btn>
                </div>
              </v-flex>
            </v-flex>
            <v-dialog
              v-model="isAddAgency"
              width="50%"
            >
              <v-card>
                <v-card-title
                  class="pf-bg-teal pf-pos-relative headline white--text"
                >
                  <small>Add agency - {{ accountObj.name || '' }}</small>
                  <v-btn class="pf-icon-top-right" icon dark @click="isAddAgency = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-autocomplete
                    v-model="newAgencies" 
                    :items="addableAgencies" 
                    multiple
                    item-text="name"
                    small-chips deletable-chips
                    item-value="id"
                    width="100%"
                    label="Search by Agency"
                    class="required pr-4 pl-4">
                    <!-- <v-icon slot="append" @click="{}"> search </v-icon> -->
                  </v-autocomplete>
                  <v-layout v-if="!addableAgencies.length">
                    <v-flex class="agencyItem pb-2" xs12>
                      <span>No records found</span>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="pf-btn pf-btn-save" @click="submitNewAgencies">
                    Save
                  </v-btn>
                  <v-btn color="white" flat @click="isAddAgency = false" class="pf-bg-pink">
                    Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-tab-item>

        <!-- Product information -->
        <v-tab-item value="tab-3">
          <v-layout>
            <v-form ref="taskDetailsForm">
              <v-layout wrap>
                <v-flex xs12 sm12 class="pl-2">
                  <h5 class="text-uppercase font-weight-bold mb-3">Production Information</h5>
                </v-flex>

                <v-flex xs12 class="px-4 mb-2 layout">
                  <v-select
                    class="date-filter"
                    v-model="filterDateCategory" 
                    label="Filter by Category" 
                    :items="[...['All'], ...dateFilterTypes]"
                    @change="filterByDateCategory"
                  >
                  </v-select>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                </v-flex>
                <!-- Date fields grid -->
                <v-layout class="px-4">
                  <table class="pf-simple-table white-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Date</th>
                        <th>Description</th>
                        <th>Category</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(dateField, d) in currentDateFields" :key="d">
                        <td>{{ d + 1 }}</td>
                        <td>
                          <VueCtkDateTimePicker button-now-translation="Today" auto-close v-if="dateField.name === 'firstMeeting'" color="#019d8c" class="px-3" @input="editTaskDetails" label="" v-model="taskDetailsObj.first_meeting.date" format="YYYY-MM-DD" formatted="L" :only-date="true" />

                          <div v-else-if="dateField.name === 'PDFUpload'" class="px-3 py-2">
                            {{ taskDetailsObj.settings.pdf_flipbook_epub_uploaded_date ? formatDateString(taskDetailsObj.settings.pdf_flipbook_epub_uploaded_date, 'MM/DD/YYYY') : '--' }}
                          </div>

                          <div v-else-if="dateField.name === 'flipbookGenerated'" class="px-3 py-2">
                            {{ taskDetailsObj.settings.pdf_flipbook_epub_uploaded_date ? formatDateString(taskDetailsObj.settings.pdf_flipbook_epub_uploaded_date, 'MM/DD/YYYY') : '--' }}
                          </div>

                          <!-- <div v-else-if="dateField.name === 'ePubGenerated'" class="px-3 py-2">
                            {{ taskDetailsObj.settings.pdf_flipbook_epub_uploaded_date ? formatDateString(taskDetailsObj.settings.pdf_flipbook_epub_uploaded_date, 'MM/DD/YYYY') : '--' }}
                          </div> -->

                          <div v-else-if="dateField.name === 'videoAppDownload'" class="px-3 py-2">
                            <!-- {{ taskDetailsObj.video_app && taskDetailsObj.video_app.downloaded_date ? formatDateString(taskDetailsObj.video_app.downloaded_date, 'MM/DD/YYYY') : '--'}} -->
                            {{ videoAppDownloadDate }}
                          </div>

                          <div v-else-if="dateField.name === 'videoProjectSubmitted'" class="px-3 py-2">
                            {{ videoProjects.length && videoProjects[0].completion_date ? formatDateString(videoProjects[0].completion_date, 'MM/DD/YYYY') : '--'}}
                          </div>

                          <VueCtkDateTimePicker button-now-translation="Today" auto-close v-else-if="dateField.name === 'videoSentForApproval'" color="#019d8c" class="px-3" @input="editTaskDetails" :only-date="true" format="YYYY-MM-DD" label="" formatted="L" v-model="taskDetailsObj.video_profile.sent_for_approval_date" />

                          <!-- <VueCtkDateTimePicker button-now-translation="Today" auto-close v-else-if="dateField.name === 'videoProfileApprovalDate'" color="#019d8c" class="px-3" @input="editTaskDetails" :only-date="true" format="YYYY-MM-DD" label="" formatted="L" v-model="projectVideo.createdAt" /> -->
                          <div v-else-if="dateField.name === 'videoProfileApprovalDate'" class="px-3 py-2">
                            {{ projectVideo && projectVideo.createdAt ? formatDateString(projectVideo.createdAt, 'MM/DD/YYYY') : '--' }}
                          </div>

                          <div v-else-if="dateField.name === 'writingReminderSentToParent'" class="px-3 py-2">
                            {{ taskDetailsObj.settings.writing_reminder_date ? formatDateString(taskDetailsObj.settings.writing_reminder_date, 'MM/DD/YYYY') : '--' }}
                          </div>

                          <div v-else-if="dateField.name === 'writingToolAccessDate'" class="px-3 py-2">
                            {{ profileDocument.createdAt ? formatDateString(profileDocument.createdAt, 'MM/DD/YYYY') : '--' }}
                          </div>

                          <div v-else-if="dateField.name === 'textApproved'" class="px-3 py-2">
                            {{ profileDocument.submitted ? formatDateString(profileDocument.submitted_date, 'MM/DD/YYYY') : '--' }}
                          </div>

                          <div v-else-if="dateField.name === 'profileSentToLayout'" class="px-3 py-2">
                            {{ profileDocument.zip_downloaded ? formatDateString(profileDocument.zip_downloaded, 'MM/DD/YYYY') : '--' }}
                          </div>

                          <div v-else-if="dateField.name === 'firstProofSent'" class="px-3 py-2">
                            {{ firstProofDate }}
                          </div>

                          <VueCtkDateTimePicker button-now-translation="Today" auto-close v-else-if="dateField.name === 'satisfactionSurveySent'" color="#019d8c" class="px-3" @input="editTaskDetails" :only-date="true" format="YYYY-MM-DD" label="" formatted="L" v-model="taskDetailsObj.survey.sent_date" />

                          <VueCtkDateTimePicker button-now-translation="Today" auto-close v-else-if="dateField.name === 'satisfactionSurveyReceived'" color="#019d8c" class="px-3" @input="editTaskDetails" id="survey_received_date" :only-date="true" format="YYYY-MM-DD" label="" formatted="L" v-model="taskDetailsObj.survey.received_date" />

                          <div v-else-if="dateField.name === 'profileProofApproved'" class="px-3 py-2">
                            {{ profileProofApprovedDate }}
                          </div>

                          <div v-else-if="dateField.name === 'profileCompletion'" class="px-3 py-2">
                            {{ taskDetailsObj.settings.pdf_flipbook_epub_uploaded_date ? formatDateString(taskDetailsObj.settings.pdf_flipbook_epub_uploaded_date, 'MM/DD/YYYY') : '--' }}
                          </div>

                          <VueCtkDateTimePicker button-now-translation="Today" auto-close v-else-if="dateField.name === 'featuredInPFSocialMedia'" class="px-3" color="#019d8c" @input="editTaskDetails" :only-date="true" format="YYYY-MM-DD" label="" formatted="L" v-model="taskDetailsObj.social_media.pf_featured_date" />

                          <div v-else-if="dateField.name === 'websiteLiveOn'" class="px-3 py-2">
                            {{ taskDetailsObj.website.live_date ? formatDateString(taskDetailsObj.website.live_date, 'MM/DD/YYYY') : '--' }}
                          </div>

                        </td>
                        <td>{{ dateField.text }}</td>
                        <td>{{ dateField.type }}</td>
                      </tr>
                      
                    </tbody>
                  </table>
                </v-layout>

                <!-- <v-layout wrap class="mt-4"> -->
                  
                  <!-- First column -->
                  <!-- <v-flex sm6 class="px-2"> -->
                    
                    <!-- <v-flex class="flex-align-center my-2">
                      <v-checkbox
                        v-model="taskDetailsObj.first_meeting.is_done"
                        label="Had first Meeting"
                        @change="isFormDataChanged = true"
                        class="px-3"
                        v-if="task_details_settings.first_meeting"
                      >
                      </v-checkbox>
                    </v-flex> -->
                    <!-- <v-flex class="py-2">
                      <VueCtkDateTimePicker button-now-translation="Today" :disabled="!taskDetailsObj.first_meeting.is_done" v-if="task_details_settings.first_meeting" color="#019d8c" class="pl-3 pr-3 mt-3 mb-3" @input="isFormDataChange($event)" id="first_meeting_datetime" label="First meeting  date" v-model="taskDetailsObj.first_meeting.date" />
                    </v-flex> -->
                    <!-- <v-flex class="py-2">
                      <v-select
                        v-model="profileDocument.writer"
                        label="Writing coach is"
                        :items="writersList"
                        item-text="name"
                        item-value="id"
                        class="pr-3 pl-3"
                        @change="updateProfileDocument"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex class="py-2">
                      <v-select
                        v-model="profileDocument.designer"
                        label="Designer is"
                        :items="designersList"
                        item-text="name"
                        item-value="id"
                        class="pr-3 pl-3"
                        @change="updateProfileDocument"
                      >
                      </v-select>
                    </v-flex> -->
                    <!-- <v-flex class="py-3 flex-align-center pl-3 pr-3 flex-row">
                      <v-checkbox
                        v-if="task_details_settings.writing_reminder"
                        v-model="taskDetailsObj.settings.writing_reminder"
                        label="Email parents a writing reminder"
                        @change="isFormDataChanged = true"
                        class="px-3"
                      >
                      </v-checkbox>
                      <label class="v-label theme--light">Writing reminder sent to parents</label>
                      <span class="font-weight-normal pf-font-16">{{ taskDetailsObj.settings.writing_reminder_date ? formatDateString(taskDetailsObj.settings.writing_reminder_date, 'LL') : 'N/A'}}</span>
                    </v-flex> -->
                    <!-- <v-flex class="py-3 flex-align-center pl-3 pr-3 flex-row">
                      <v-checkbox
                        v-model="taskDetailsObj.settings.text_approved"
                        label="Text is approved"
                        v-if="task_details_settings.text_approved"
                        @change="isFormDataChanged = true"
                        class="px-3"
                        disabled
                      >
                      </v-checkbox>
                      <label class="v-label theme--light">Text is approved</label>
                      <span class="font-weight-normal pf-font-16">{{ profileDocument.submitted ? formatDateString(profileDocument.submitted_date, 'LL') : 'N/A'}}</span>
                    </v-flex> -->
                    <!-- <v-flex class="py-3 flex-align-center pl-3 pr-3 flex-row">
                      <v-checkbox
                        v-if="task_details_settings.profile_sent_layout"
                        v-model="taskDetailsObj.settings.profile_sent"
                        label="Profile sent to layout"
                        @change="isFormDataChanged = true"
                        class="px-3">
                      </v-checkbox>
                      <label class="v-label theme--light">Profile sent to layout</label>
                      <span class="font-weight-normal pf-font-16">{{ profileDocument.zip_downloaded ? formatDateString(profileDocument.zip_downloaded, 'LL') : 'N/A'}}</span>
                    </v-flex> -->
                    <!-- <v-flex class="py-3 flex-align-center pl-3 pr-3 flex-row">
                      <v-checkbox
                        v-if="task_details_settings.sent_first_proof"
                        v-model="taskDetailsObj.settings.sent_first_proof"
                        label="Sent first proof"
                        @change="isFormDataChanged = true"
                        class="px-3">
                      </v-checkbox>
                      <label class="v-label theme--light">Sent first proof</label>
                      <span class="font-weight-normal pf-font-16">{{ firstProofDate }}</span>
                    </v-flex> -->
                    <!-- <v-flex class="py-2">
                      <v-checkbox
                        v-if="task_details_settings.survey_sent"
                        v-model="taskDetailsObj.survey.is_sent"
                        label="Satisfation survey sent"
                        @change="isFormDataChanged = true"
                        class="px-3">
                      </v-checkbox>
                    </v-flex> -->
                    <!-- <v-flex class="py-2">
                      <VueCtkDateTimePicker button-now-translation="Today" v-if="taskDetailsObj.survey.is_sent" color="#019d8c" class="pl-3 pr-3 mt-3 mb-3" @input="isFormDataChange($event)" id="survey_sent_date" :only-date="true" format="YYYY-MM-DD" label="Date satisfaction survey sent" formatted="L" v-model="taskDetailsObj.survey.sent_date" />
                    </v-flex> -->
                    <!-- <v-flex class="py-2">
                      <VueCtkDateTimePicker button-now-translation="Today" color="#019d8c" class="pl-3 pr-3 mt-3 mb-3" @input="isFormDataChange($event)" id="survey_received_date" :only-date="true" format="YYYY-MM-DD" label="Date satisfaction survey received" formatted="L" v-model="taskDetailsObj.survey.received_date" />
                    </v-flex> -->
                    <!-- <v-flex class="mt-5 mb-2">
                      <v-checkbox
                        v-model="taskDetailsObj.profile_proof.approved"
                        label="Profile proof is approved"
                        @change="isFormDataChanged = true"
                        v-if="task_details_settings.profile_proof_approved"
                        class="px-3">
                      </v-checkbox>
                    </v-flex> -->
                    <!-- <v-flex class="py-3 flex-align-center pl-3 pr-3 flex-row">
                      <VueCtkDateTimePicker button-now-translation="Today" v-if="task_details_settings.profile_proof_approved" color="#019d8c" class="pl-3 pr-3 mt-3 mb-3" @input="isFormDataChange($event)" id="profile_proof_approved_date" :only-date="true" format="YYYY-MM-DD" label="Profile proof approved" formatted="L" v-model="taskDetailsObj.profile_proof.approved_date" />
                      <label class="v-label theme--light">Profile proof approved</label>
                      <span class="font-weight-normal pf-font-16">{{ profileProofApprovedDate }}</span>
                    </v-flex> -->
                    <!-- <v-flex class="py-2">
                      <v-checkbox
                        v-model="taskDetailsObj.social_media.dont_feature"
                        label="Don't feature in social media"
                        @change="isFormDataChanged = true"
                        class="px-3">
                      </v-checkbox>
                    </v-flex> -->
                    <!-- <v-flex class="py-2">
                      <v-checkbox
                        v-model="taskDetailsObj.social_media.pf_featured_date"
                        label="Featured in PF social media"
                        @change="isFormDataChanged = true"
                        v-if="taskDetailsObj.social_media.dont_feature"
                        class="px-3">
                      </v-checkbox>
                    </v-flex> -->
                    <!-- <v-flex class="py-2">
                      <VueCtkDateTimePicker button-now-translation="Today" v-if="taskDetailsObj.social_media.dont_feature" color="#019d8c" class="pl-3 pr-3 mt-3 mb-3" @input="isFormDataChange($event)" id="social_media_featured_date" :only-date="true" format="YYYY-MM-DD" label="Date featured in PF social media" formatted="L" v-model="taskDetailsObj.social_media.pf_featured_date" />
                    </v-flex> -->
                  <!-- </v-flex> -->

                  <!-- Second column -->
                  <!-- <v-flex sm6 class="px-2"> -->

                    <!-- <v-flex class="py-2">
                      <v-checkbox
                        v-model="taskDetailsObj.printed_profiles.is_ordered"
                        label="Printed profiles ordered"
                        @change="isFormDataChanged = true"
                        v-if="task_details_settings.printed_profiles_ordered"
                        class="px-3">
                      </v-checkbox>
                    </v-flex> -->
                    <!-- <v-flex class="py-2">
                      <v-text-field v-if="taskDetailsObj.printed_profiles.ordered_date" v-model="taskDetailsObj.printed_profiles.tracking_number" label="Printed profile tracking number" class="px-3" @input="isFormDataChanged = true"></v-text-field>
                    </v-flex> -->
                    <!-- <v-flex class="py-2">
                      <v-checkbox
                        v-model="taskDetailsObj.printed_profiles.is_shipping"
                        label="Profiles are shipping"
                        @change="isFormDataChanged = true"
                        v-if="task_details_settings.profiles_shipping"
                        class="px-3">
                      </v-checkbox>
                    </v-flex> -->
                    <!-- <v-flex class="py-2">
                      <v-text-field v-if="taskDetailsObj.printed_profiles.shipped_date" v-model="taskDetailsObj.printed_profiles.ship_to_address" label="Printed profile shiped to address" class="px-3" @input="isFormDataChanged = true"></v-text-field>
                    </v-flex> -->
                    <!-- <v-flex class="py-2">
                      <VueCtkDateTimePicker button-now-translation="Today" color="#019d8c" class="pl-3 pr-3 mt-3 mb-3" @input="isFormDataChange($event)" id="printed_profiles_delivery_date" :only-date="true" format="YYYY-MM-DD" label="Printed profile delivery date" formatted="L" v-model="taskDetailsObj.printed_profiles.delivery_date" />
                    </v-flex> -->
                    <!-- <v-flex class="py-3 flex-align-center pl-3 pr-3 flex-row">
                      <v-checkbox
                        v-if="task_details_settings.pdf_flipbook_epub_uploaded"
                        v-model="taskDetailsObj.settings.pdf_flipbook_epub_uploaded"
                        label="PDF, Flipbook, ePub uploaded into PF"
                        @change="isFormDataChanged = true"
                      class="px-3">
                      </v-checkbox>
                      <label class="v-label theme--light">PDF, Flipbook, ePub uploaded into PF</label>
                      <span class="font-weight-normal pf-font-16">{{ taskDetailsObj.settings.pdf_flipbook_epub_uploaded_date ? formatDateString(taskDetailsObj.settings.pdf_flipbook_epub_uploaded_date, 'LL') : 'N/A'}}</span>
                    </v-flex> -->
                    <!-- <v-flex class="py-3 flex-align-center pl-3 pr-3 flex-row">
                      <VueCtkDateTimePicker button-now-translation="Today" color="#019d8c" class="pl-3 pr-3 mt-3 mb-3" @input="isFormDataChange($event)" id="date_video_app_downloaded" label="Date video app downloaded" v-model="taskDetailsObj.video_app.downloaded_date" />
                      <label class="v-label theme--light">Date video app downloaded</label>
                      <span class="font-weight-normal pf-font-16">{{ taskDetailsObj.video_app && taskDetailsObj.video_app.downloaded_date ? formatDateString(taskDetailsObj.video_app.downloaded_date, 'LL') : 'N/A'}}</span>
                    </v-flex> -->
                    <!-- <v-flex class="py-3 flex-align-center pl-3 pr-3 flex-row">
                      <v-checkbox
                        v-if="task_details_settings.video_profile_submitted_all_videos"
                        v-model="taskDetailsObj.video_profile.submitted_video_project"
                        label="Parents submitted video project"
                        @change="isFormDataChanged = true"
                        class="px-3">
                      </v-checkbox>
                      <label class="v-label theme--light">Parents submitted video project</label>
                      <span class="font-weight-normal pf-font-16">{{ videoProjects.length && videoProjects[0].completion_date ? formatDateString(videoProjects[0].completion_date, 'LL') : 'N/A'}}</span>
                    </v-flex> -->
                    <!-- <v-flex class="py-2">
                      <VueCtkDateTimePicker button-now-translation="Today" color="#019d8c" class="pl-3 pr-3 mt-3 mb-3" @input="isFormDataChange($event)" id="video_profile_sent_for_approval_date" :only-date="true" format="YYYY-MM-DD" label="Video profile sent for approval" formatted="L" v-model="taskDetailsObj.video_profile.sent_for_approval_date" />
                    </v-flex> -->
                    <!-- <v-flex class="py-3 flex-align-center pl-3 pr-3 flex-row">
                      <VueCtkDateTimePicker button-now-translation="Today" color="#019d8c" class="mt-3 mb-3" @input="isFormDataChange($event)" id="video_profile_approved_date" :only-date="true" format="YYYY-MM-DD" label="Video profile approved" formatted="L" v-model="projectVideo.createdAt" />
                      <label class="v-label theme--light">Video profile approved</label>
                      <span class="font-weight-normal pf-font-16">{{ taskDetailsObj.video_profile.approved_date ? formatDateString(taskDetailsObj.video_profile.approved_date, 'LL') : 'N/A'}}</span>
                    </v-flex> -->
                    <!-- <v-flex class="py-3 flex-align-center pl-3 pr-3 flex-row">
                      <v-checkbox
                        v-if="task_details_settings.website_live"
                        v-model="taskDetailsObj.website.is_live"
                        label="Parent's website is live"
                        @change="isFormDataChanged = true"
                        class="px-3">
                      </v-checkbox>
                      <label class="v-label theme--light">Parent's website is live</label>
                      <span class="font-weight-normal pf-font-16">{{ taskDetailsObj.website.live_date ? formatDateString(taskDetailsObj.website.live_date, 'LL') : 'N/A'}}</span>
                    </v-flex> -->
                    <!-- <v-flex class="py-2">
                      <v-text-field readonly v-model="accountObj.contactInfo.website" label="Website URL" class="px-3" @input="isFormDataChanged = true"></v-text-field>
                    </v-flex> -->
                    <!-- <v-flex class="py-3 flex-align-center pl-3 pr-3 flex-row">
                      <VueCtkDateTimePicker button-now-translation="Today" v-if="task_details_settings.profile_completed" color="#019d8c" class="pl-3 pr-3 mt-3 mb-3" @input="isFormDataChange($event)" id="profile_completed_date" :only-date="true" format="YYYY-MM-DD" label="Profile completed" formatted="L" v-model="taskDetailsObj.video_profile.approved_date" />
                      <label class="v-label theme--light">Profile completed date</label>
                      <span class="font-weight-normal pf-font-16">{{ taskDetailsObj.settings.pdf_flipbook_epub_uploaded_date ? formatDateString(taskDetailsObj.settings.pdf_flipbook_epub_uploaded_date, 'LL') : 'N/A' }}</span>
                    </v-flex> -->
                  <!-- </v-flex> -->
                <!-- </v-layout> -->

                <!-- <v-flex xs12 class="my-4 pr-0 pl-2" v-if="isFormDataChanged">
                  <div class="d-inline-flex">
                    <v-btn class="pf-btn pf-btn-save" v-if="accountObj.task_details" @click="editTaskDetails">
                      <v-icon size="16" class="pr-1">check_circle</v-icon>
                      <div>Save</div>
                    </v-btn>
                    <v-btn class="pf-btn pf-btn-save" v-else @click="save">
                      <v-icon size="16" class="pr-1">check_circle</v-icon>
                      <div>Save</div>
                    </v-btn>
                    <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                      <v-icon size="16" class="pr-1">cancel</v-icon>
                      <div>Cancel</div>
                    </v-btn>
                  </div>
                </v-flex> -->
              </v-layout>
            </v-form>
          </v-layout>
        </v-tab-item>

        <!-- Profile URLs -->
        <v-tab-item value="tab-4">
          <v-layout>
            <v-form ref="profileURLForm">
              <v-flex class="pl-2">
                <h5 class="text-uppercase font-weight-bold mb-3">Profile URLs</h5>
              </v-flex>
              <!-- <v-flex xs12 class="py-2">
                <p class="ml-2 mb-0 pf-font-16">
                Parentfinder URL - <a :href="getFamilyBadgeURL" class="wrap-break-word" v-if="getFamilyBadgeURL" target="_blank">{{ getFamilyBadgeURL }}</a>
                  <span v-else class="pa-1 bg-redish white--text">No badge profile found</span>
                  <v-btn icon fab class="pf-text-teal ma-0"
                    v-if="getFamilyBadgeURL"
                    v-clipboard:copy="getFamilyBadgeURL"
                    v-clipboard:success="onCopySuccess"
                    v-clipboard:error="{}">
                    <v-icon size="20" class="pr-1">file_copy</v-icon>
                  </v-btn>
                </p>
              </v-flex>
              <v-flex xs12 class="py-2">
                <p class="ml-2 mb-0 pf-font-16">
                  Link to Flipbook - <a :href="getFlipbookURL" class="wrap-break-word" v-if="getFlipbookURL" target="_blank">{{ getFlipbookURL }}</a>
                  <span v-else class="pa-1 bg-redish white--text">No profile book found</span>
                  <v-btn icon fab class="pf-text-teal ma-0"
                    v-if="getFlipbookURL"
                    v-clipboard:copy="getFlipbookURL"
                    v-clipboard:success="onCopySuccess"
                    v-clipboard:error="{}">
                    <v-icon size="20" class="pr-1">file_copy</v-icon>
                  </v-btn>
                </p>
              </v-flex>
              <v-flex xs12 class="py-2">
                <p class="ml-2 mb-0 pf-font-16">
                  Parent Website URL - <a :href="accountObj.contactInfo.website" class="wrap-break-word" v-if="accountObj.contactInfo.website" target="_blank">{{ accountObj.contactInfo.website }}</a>
                  <span v-else class="pa-1 bg-redish white--text">No URL found</span>
                  <v-btn icon fab class="pf-text-teal ma-0"
                    v-if="accountObj.contactInfo.website"
                    v-clipboard:copy="accountObj.contactInfo.website"
                    v-clipboard:success="onCopySuccess"
                    v-clipboard:error="{}">
                    <v-icon size="20" class="pr-1">file_copy</v-icon>
                  </v-btn>
                </p>
              </v-flex> -->
              <v-layout wrap row align-center :class="{ 'mb-3': accountObj.membership !== 'Network' }">
                <v-flex xs1 align-center>
                  <v-btn icon depressed color="pf-bg-pink">
                    <v-icon size="18" class="icon-color">link</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs11>
                  <p class="ml-2 mb-0 pf-font-16">
                    Badge Profile - <a :href="getFamilyBadgeURL" class="wrap-break-word" v-if="getFamilyBadgeURL" target="_blank">{{ getFamilyBadgeURL }}</a>
                    <span v-else class="bg-redish">No badge profile found</span>
                    <v-btn icon fab class="pf-text-teal ma-0"
                      v-if="getFamilyBadgeURL"
                      v-clipboard:copy="getFamilyBadgeURL"
                      v-clipboard:success="onCopySuccess"
                      v-clipboard:error="{}">
                      <v-icon size="20" class="pr-1">file_copy</v-icon>
                    </v-btn>
                  </p>
                </v-flex>
              </v-layout>
              <v-layout wrap row align-center :class="{ 'mb-3': accountObj.membership !== 'Network' }">
                <v-flex xs1 align-center>
                  <v-btn icon depressed color="pf-bg-blue">
                    <v-icon size="18" class="icon-color">auto_stories</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs11>
                  <p class="ml-2 mb-0 pf-font-16">
                    Flipbook - <a :href="getFlipbookURL" class="wrap-break-word" v-if="getFlipbookURL" target="_blank">{{ getFlipbookURL }}</a>
                    <span v-else class="bg-redish">No flipbook found</span>
                    <v-btn icon fab class="pf-text-teal ma-0"
                      v-if="getFlipbookURL"
                      v-clipboard:copy="getFlipbookURL"
                      v-clipboard:success="onCopySuccess"
                      v-clipboard:error="{}">
                      <v-icon size="20" class="pr-1">file_copy</v-icon>
                    </v-btn>
                  </p>
                </v-flex>
              </v-layout>
              <v-layout wrap row align-center v-if="accountObj.membership !== 'Network'">
                <v-flex xs1 align-center>
                  <v-btn icon depressed color="pf-bg-green">
                    <v-icon size="18" class="icon-color">language</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs11>
                  <p class="ml-2 mb-0 pf-font-16">
                    Website - <a :href="getFamilyURL" class="wrap-break-word" v-if="getFamilyURL" target="_blank">{{ getFamilyURL }}</a>
                    <span v-else class="bg-redish">No website found</span>
                    <v-btn icon fab class="pf-text-teal ma-0"
                      v-if="getFamilyURL"
                      v-clipboard:copy="getFamilyURL"
                      v-clipboard:success="onCopySuccess"
                      v-clipboard:error="{}">
                      <v-icon size="20" class="pr-1">file_copy</v-icon>
                    </v-btn>
                  </p>
                </v-flex>
              </v-layout>
              <v-layout class="button-container pr-4" :class="{'pl-4': $vuetify.breakpoint.smAndUp}"> 
                <v-flex xs12 sm12 md12 class="pr-0 text-xs-right">
                  <div class="d-inline-flex">
                    <v-btn class="pf-btn pf-btn-save" @click="saveURLs">
                      <v-icon size="16" class="pr-1">check_circle</v-icon>
                      <div>Save</div>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout wrap row align-center>
                <v-flex md1 sm2 xs3 align-center>
                    <v-btn icon depressed color="bg-facebook">
                        <v-icon size="17" class="icon-color">fa fa-facebook</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex md6 sm8 xs6>
                  <v-text-field spellcheck="false" hint="https://facebook.com/username" :rules="[rules.URLRules, rules.facebookRule, rules.validLink]" @input="dirty=true" v-model="socialAccounts.facebook.url" label="Enter URL">
                </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap row align-center>
                <v-flex md1 sm2 xs3 align-center>
                    <v-btn icon depressed color="bg-tiktok">
                        <v-icon size="17" class="icon-color">tiktok</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex md6 sm8 xs6>
                  <v-text-field spellcheck="false" hint="https://tiktok.com/username" :rules="[rules.URLRules, rules.ticktokRule]" @input="dirty=true" v-model="socialAccounts.tiktok.url" label="Enter URL">
                </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap row align-center>
                <v-flex md1 sm2 xs3 align-center>
                    <v-btn icon depressed color="bg-twitter">
                        <v-icon size="17" class="icon-color">fab fa-twitter</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex md6 sm8 xs6>
                  <v-text-field spellcheck="false" hint="https://twitter.com/username" :rules="[rules.URLRules, rules.twitterRule]" @input="dirty=true" v-model="socialAccounts.twitter.url" label="Enter URL">
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap row align-center>
                <v-flex md1 sm2 xs3 align-center>
                    <v-btn icon depressed color="bg-blogger">
                        <v-icon size="17" class="icon-color">fab fa-blogger-b</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex md6 sm8 xs6>
                  <v-text-field spellcheck="false" hint="https://blogger.com/username" :rules="[rules.URLRules, rules.bloggerRule]" @input="dirty=true" v-model="socialAccounts.blogger.url" label="Enter URL">
                </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap row align-center>
                <v-flex md1 sm2 xs3 align-center>
                    <v-btn icon depressed color="bg-instagram">
                        <v-icon size="17" class="icon-color">fab fa-instagram</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex md6 sm8 xs6>
                    <v-text-field spellcheck="false" hint="https://instagram.com/username" :rules="[rules.URLRules, rules.instagramRule]" @input="dirty=true" v-model="socialAccounts.instagram.url" label="Enter URL">
                    </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap row align-center pb-5>
                <v-flex md1 sm2 xs3 align-center>
                    <v-btn icon depressed color="bg-pinterest">
                        <v-icon size="17" class="icon-color">fab fa-pinterest-p</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex md6 sm8 xs6>
                    <v-text-field spellcheck="false" hint="https://pinterest.com/username" :rules="[rules.URLRules, rules.pintrestRule]" @input="dirty=true" v-model="socialAccounts.pinterest.url" label="Enter URL">
                    </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="button-container pr-4" :class="{'pl-4': $vuetify.breakpoint.smAndUp}"> 
                <v-flex xs12 sm12 md12 class="pr-0 text-xs-right">
                  <div class="d-inline-flex">
                    <v-btn class="pf-btn pf-btn-save" @click="saveURLs">
                      <v-icon size="16" class="pr-1">check_circle</v-icon>
                      <div>Save</div>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-layout>
        </v-tab-item>

        <!-- Notes -->
        <v-tab-item value="tab-5">
          <v-flex xs12 sm12 class="pl-2">
            <h5 class="text-uppercase font-weight-bold mb-3">Notes</h5>
          </v-flex>
          <v-form ref="noteListForm">
            <template v-if="!isAddNote">
              <template v-if="editMode">
                <v-layout class="button-container flex-space-between pr-4 mb-3">
                  <v-btn fab absolute left @click="cancelAddNote" class="pf-btn-fab">
                    <v-icon>arrow_back</v-icon>
                  </v-btn>
                  <v-flex xs12 sm12 md12 class="pr-0 text-xs-right" v-if="isFormDataChanged">
                    <div class="d-inline-flex">
                      <v-btn class="pf-btn pf-btn-cancel" @click="backToList">
                        <v-icon size="16" class="pr-1">cancel</v-icon>
                        <div>Cancel</div>
                      </v-btn>
                      <v-btn class="pf-btn pf-btn-save" @click="updateNote">
                        <v-icon size="16" class="pr-1">check_circle</v-icon>
                        <div>Save</div>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field outline v-model.trim="editableNoteObj.title" label="Note title" class="pl-3 pr-3 required" :rules="[rules.required]" @input="isFormDataChanged = true"></v-text-field>
                    <v-textarea outline v-model="editableNoteObj.note" rows="10" label="Note" class="px-3" @input="isFormDataChanged = true"></v-textarea>
                    <v-select 
                      v-model="adminTags" 
                      :items="adminList"
                      @change="isFormDataChanged = true" 
                      small-chips
                      deletable-chips 
                      label="Tag admins" 
                      multiple 
                      hint="The note will be sent to the tagged people"
                      persistent-hint
                      class="pr-4 pl-4">
                    </v-select>
                    <v-flex xs12 sm6 class="mt-3">
                      <v-checkbox
                        v-model="editableNoteObj.issue"
                        value="Yes"
                        label="This is an issue"
                        @change="isFormDataChanged = true"
                        class="pr-4 pl-4">
                      </v-checkbox>
                    </v-flex>
                      <upload-btn multiple @file-update="fileSelected($event)" noTitleUpdate :title="selectTitle">
                        <template slot="icon">
                            <v-icon right dark>cloud_upload</v-icon>
                        </template>
                        <template slot="text-field"></template>
                      </upload-btn>
                      <v-layout v-if="editableNoteObj.files.length" xs12 xs6 class="d-block mr-4 ml-4 mt-2">
                        <p pa-0><label>Seleted files</label></p>
                        <template v-for="(file, i) in editableNoteObj.files">
                          <span :key="i">
                            <v-chip
                              close
                              @input="removeNoteFile(file)"
                            >
                              <span>{{ file.name }}</span>
                            </v-chip>
                          </span>
                        </template>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout class="button-container pr-4 pl-4">
                  <v-flex xs12 sm12 md12 class="pr-0 text-xs-right" v-if="isFormDataChanged">
                    <div class="d-inline-flex">
                      <v-btn class="pf-btn pf-btn-cancel" @click="backToList">
                        <v-icon size="16" class="pr-1">cancel</v-icon>
                        <div>Cancel</div>
                      </v-btn>
                      <v-btn class="pf-btn pf-btn-save" @click="updateNote">
                        <v-icon size="16" class="pr-1">check_circle</v-icon>
                        <div>Save</div>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </template>
              <template v-else-if="viewNoteObj">
                <v-layout class="button-container flex-space-between pr-4 mb-3">
                  <v-btn fab absolute left @click="cancelViewNote" class="pf-btn-fab">
                    <v-icon>arrow_back</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="px-4">
                  <table class="pf-plain-table">
                    <tr>
                      <th>Title</th>
                      <td>{{ viewNoteObj.title }}</td>
                    </tr>
                    <tr>
                      <th>Note</th>
                      <td>{{ viewNoteObj.note }}</td>
                    </tr>
                    <tr>
                      <th>Attachments</th>
                      <td>
                        <v-layout v-if="viewNoteObj.files.length" xs12 xs6 class="d-block">
                          <template v-for="(file, i) in viewNoteObj.files">
                            <a :key="i" target="_blank" :href="`${config.uploadPath}${file.webPath}`">{{ file.name }}</a>
                          </template>
                        </v-layout>
                        <span v-else>--</span>
                      </td>
                    </tr>
                    <tr>
                      <th>Tagged to</th>
                      <td>{{ viewNoteObj.human.map(x => adminList[adminList.findIndex(a => a.value === x)].text).join(', ') }}</td>
                    </tr>
                    <tr>
                      <th width="200">Is issue</th>
                      <td>{{ viewNoteObj.issue }}</td>
                    </tr>
                    <tr>
                      <th>Actions</th>
                      <td>
                        <v-btn icon class="ma-0" @click="editNotes(viewNoteObj)" small>
                          <v-icon size="22" color="grey darken-2">edit</v-icon>
                        </v-btn>
                        <v-btn icon class="ma-0" @click="deleteNotes(viewNoteObj)" small>
                          <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                    <tr>
                    </tr>
                  </table>
                </v-layout>
              </template>
              <v-container fluid v-else>
                <div>
                  <v-layout class="pb-0">
                    <!-- <v-select
                      v-model="searchNotes"
                      append-icon="search"
                      label="Search by Recent time"
                      :items="selectList"
                      @change="sortByDate"
                      outline
                      single-line
                    ></v-select> -->
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchNotes"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>

                    <v-flex class="mb-5">
                      <v-btn v-if="editMode" fab absolute left @click="editMode = false" class="ml-3 pf-btn-fab">
                        <v-icon>arrow_back</v-icon>
                      </v-btn>
                      <!-- <v-btn fab absolute right v-if="!editMode" @click="isAddNote = true" class="ml-3 pf-btn-fab">
                        <v-icon>add</v-icon>
                      </v-btn> -->
                    </v-flex>
                  </v-layout>
                  <v-card class="mt-3">
                    <v-data-table
                      :headers="notesHeaders"
                      :items="notesList"
                      class="pf-data-table"
                      ref="sortableTable"
                      :pagination.sync="notesPagination"
                      :search="searchNotes"
                      no-data-text="No notes found"
                    >
                      <template v-slot:items="props">
                        <tr>
                          <td>{{ formatDateString(props.item.createdAt, 'MM/DD/YYYY hh:mm a') }}</td>
                          <td>{{ props.item.createdBy && props.item.createdBy.human ? props.item.createdBy.human.name : '--' }}</td>
                          <td>{{ props.item.title ? props.item.title : '--' }}</td>
                          <td>{{ props.item.human.map(x => adminList[adminList.findIndex(a => a.value === x)].text).join(', ') || 'None' }}</td>
                          <!-- <td>{{ props.item.note ? props.item.note : '--' }}</td> -->
                          <!-- <td width="150px" v-if="props.item.files.length === 0">No files found</td>
                          <td width="150px" v-else>
                            <div v-for="(file, index) in props.item.files" :key="file._id">
                              <span>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <span v-on="on" class="pointer">file {{ index + 1 }}</span>
                                  </template>
                                <span>{{ file.name }}</span>
                            </v-tooltip>
                                <v-btn icon class="ma-0" v-if="file.mimetype.lastIndexOf('image/') !== -1" @click="viewImage(`${config.uploadPath}${file.webPath}`)">
                                  <v-icon small color="grey darken-2">remove_red_eye</v-icon>
                                </v-btn>
                                <v-btn icon class="ma-0" @click="downloadImage(`${config.uploadPath}${file.webPath}`)">
                                  <v-icon small color="grey darken-2">save_alt</v-icon>
                                </v-btn>
                              </span>
                            </div>
                          </td> -->
                          <td align="right">
                            <v-icon v-if="props.item.files && props.item.files.length" size="22" color="grey">attachment</v-icon>
                            <v-menu offset-y>
                              <template v-slot:activator="{ on }">
                              <v-btn icon small class="mr-0 ml-0" v-on="on">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                <v-icon size="22" color="grey darken-2" v-on="on">apps</v-icon>
                                </template>
                                  <span>More</span>
                                </v-tooltip>
                              </v-btn>
                              </template>
                              <v-list class="familyOptions">
                                <v-list-tile @click="viewNote(props.item)">
                                  <v-list-tile-action>
                                    <v-icon size="22" color="grey darken-2">remove_red_eye</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-title >
                                      View
                                    </v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile @click="editNotes(props.item)">
                                  <v-list-tile-action>
                                    <v-icon size="22" color="grey darken-2">edit</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-title >
                                      Edit
                                    </v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile @click="deleteNotes(props.item)">
                                  <v-list-tile-action>
                                    <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-title >
                                      Delete
                                    </v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </v-list>
                            </v-menu>
                            <!-- <v-tooltip top>
                              <template v-slot:activator="{ on }">
                              <span v-on="on">
                                <v-btn icon class="ma-0" @click="viewNote(props.item)">
                                  <v-icon size="22" color="grey darken-2">remove_red_eye</v-icon>
                                </v-btn>
                              </span>
                              </template>
                              <span>View</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                              <span v-on="on">
                                <v-btn icon class="ma-0" @click="editNotes(props.item)" small>
                                  <v-icon size="22" color="grey darken-2">edit</v-icon>
                                </v-btn>
                              </span>
                              </template>
                              <span>Edit</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                              <span v-on="on">
                                <v-btn icon class="ma-0" @click="deleteNotes(props.item)" small>
                                  <v-icon size="22" color="grey darken-2" >delete_outline</v-icon>
                                </v-btn>
                              </span>
                              </template>
                              <span>Delete</span>
                            </v-tooltip> -->
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </div>
                <v-layout row justify-center>
                  <v-dialog v-model="dialog" class="text-xs-center" max-width="400">
                    <v-layout wrap>
                      <v-card>
                        <v-card-actions class="text-xs-right">
                          <v-spacer></v-spacer>
                          <v-icon @click="dialog=!dialog" size="32" color="#f195bf" class="pr-1">cancel</v-icon>
                        </v-card-actions>
                        <img
                          class="image_class_dialog"
                          :src="DialogImg"
                          height="100%"
                          width="100%"
                        />
                      </v-card>
                    </v-layout>
                  </v-dialog>
                </v-layout>
              </v-container>
            </template>
            <template v-else>
              <v-btn fab absolute left @click="cancelAddNote" class="ml-3 pf-btn-fab">
                <v-icon>arrow_back</v-icon>
              </v-btn>
              <v-form ref="addNotesForm">
                <v-container fluid>
                  <v-layout class="button-container pr-4 pl-4">
                    <v-flex xs12 sm12 md12 class="pr-0 text-xs-right" v-if="isFormDataChanged">
                      <div class="d-inline-flex">
                        <v-btn class="pf-btn pf-btn-cancel" @click="addNotesCancel">
                          <v-icon size="16" class="pr-1">cancel</v-icon>
                          <div>Cancel</div>
                        </v-btn>
                        <v-btn class="pf-btn pf-btn-save" @click="addNotesUpload">
                          <v-icon size="16" class="pr-1">check_circle</v-icon>
                          <div>Save</div>
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field outline v-model.trim="AddNewNotes.title" label="Note title" class="pl-3 pr-3 required" :rules="[rules.required]" @input="isFormDataChanged = true"></v-text-field>
                      <v-textarea outline v-model.trim="AddNewNotes.note" rows="10" label="Note" class="px-3" @input="isFormDataChanged = true"></v-textarea>
                      <v-select 
                        v-model="adminTags" 
                        :items="adminList"
                        @change="isFormDataChanged = true"
                        small-chips
                        deletable-chips 
                        label="Tag admins" 
                        multiple 
                        hint="The note will be sent to the tagged people"
                        persistent-hint
                        class="pr-4 pl-4">
                      </v-select>
                      <v-flex xs12 sm6 class="mt-3">
                        <v-checkbox
                          v-model="AddNewNotes.issue"
                          value="Yes"
                          label="This is an issue"
                          @change="isFormDataChanged = true"
                          class="pr-4 pl-4">
                        </v-checkbox>
                      </v-flex>
                      <upload-btn multiple @file-update="fileSelected($event, true)" noTitleUpdate :title="selectTitle">
                        <template slot="icon">
                            <v-icon right dark>cloud_upload</v-icon>
                        </template>
                        <template slot="text-field"></template>
                      </upload-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout class="button-container pr-4 pl-4">
                    <v-flex xs12 sm12 md12 class="pr-0 text-xs-right" v-if="isFormDataChanged">
                      <div class="d-inline-flex">
                        <v-btn class="pf-btn pf-btn-cancel" @click="addNotesCancel">
                          <v-icon size="16" class="pr-1">cancel</v-icon>
                          <div>Cancel</div>
                        </v-btn>
                        <v-btn class="pf-btn pf-btn-save" @click="addNotesUpload">
                          <v-icon size="16" class="pr-1">check_circle</v-icon>
                          <div>Save</div>
                        </v-btn>
                      </div>
                    </v-flex>
                </v-layout>
                </v-container>
            </v-form>
            </template>
          </v-form>
        </v-tab-item>

        <!-- Surveys -->
        <v-tab-item value="tab-6">
          <v-flex xs12 sm12 class="pl-2">
            <h5 class="text-uppercase font-weight-bold mb-3">Surveys</h5>
          </v-flex>
          <v-layout v-if="!isAddSurvey" class="px-3 flex-column">
            <!-- <v-flex :class="{ 'flex-end': editIndex === -1 }">
              <v-btn v-if="editIndex > -1" fab left @click="cancelEdit" class="pf-btn-fab">
                <v-icon>arrow_back</v-icon>
              </v-btn>
              <v-btn fab right v-if="editIndex === -1" @click="isAddSurvey = true" class="pf-btn-fab">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex> -->
            <!-- <v-layout v-if="editIndex > -1" class="flex-column">
              <v-layout class="pr-4 pl-4">
                <v-flex xs12 sm12 md12 class="pr-0">
                  <div class="text-xs-right" v-if="surveyChanged">
                    <v-btn class="pf-btn pf-btn-cancel" @click="cancelEdit">
                      <v-icon size="16" class="pr-1">cancel</v-icon>
                      <div>Cancel</div>
                    </v-btn>
                    <v-btn class="pf-btn pf-btn-save" @click="updateSurvey">
                      <v-icon size="16" class="pr-1">check_circle</v-icon>
                      <div>Submit</div>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
              <v-form ref="editSurveyForm">
                <v-layout wrap class="pb-4 pt-3">
                  <v-flex xs12 sm6>
                    <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" @change="surveyChanged=true" v-model="editItem.explained_clearly" label="Was the profile process explained to you clearly ?" column>
                      <v-radio label="Yes" color="success" value="Yes"></v-radio>
                      <v-radio label="No" color="success" value="No"></v-radio>
                      <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" @change="surveyChanged=true" v-model="editItem.meeting_ontime" label="Did your meeting start on the communicated date and time ?" column>
                      <v-radio label="Yes" color="success" value="Yes"></v-radio>
                      <v-radio label="No" color="success" value="No"></v-radio>
                      <v-radio label="No - but it was due to our conflict" color="success" value="No - but it was due to our conflict"></v-radio>
                      <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" @change="surveyChanged=true" v-model="editItem.helpful" label="Was the person that you worked with helpful in creating your profile ?" column>
                      <v-radio label="Yes" color="success" value="Yes"></v-radio>
                      <v-radio label="No" color="success" value="No"></v-radio>
                      <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-radio-group class="pr-4 pl-5" v-model="editItem.communicate_clearly" @change="surveyChanged=true" label="Did the person that worked with you on your profile communicate clearly ?" column>
                      <v-radio label="Yes" color="success" value="Yes"></v-radio>
                      <v-radio label="No" color="success" value="No"></v-radio>
                      <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="editItem.overall_timelines" @change="surveyChanged=true" label="Were overall timelines communicated to you ?" column>
                      <v-radio label="Yes" color="success" value="Yes"></v-radio>
                      <v-radio label="No" color="success" value="No"></v-radio>
                      <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="editItem.meet_timelines" @change="surveyChanged=true" label="Did we meet the timelines ?" column>
                      <v-radio label="Yes" color="success" value="Yes"></v-radio>
                      <v-radio label="No" color="success" value="No"></v-radio>
                      <v-radio label="No, because of our delay" color="success" value="No, because of our delay"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" @change="surveyChanged=true" v-model="editItem.rating" label="Overall satisfaction with profile creation process ?" column>
                      <v-radio label="Wow it has been great !" color="success" value="5"></v-radio>
                      <v-radio label="Very satisfied" color="success" value="4"></v-radio>
                      <v-radio label="Satisfied" color="success" value="3"></v-radio>
                      <v-radio label="Slightly satisfied" color="success" value="2"></v-radio>
                      <v-radio label="Not satisfied" color="success" value="1"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <div class="pr-4 pl-5 mt-4 v-label theme--light">Additional Feedback:</div>
                    <v-textarea
                      outline
                      class="pr-4 pl-5 mt-3"
                      name="input-7-4"
                      label="Your feedback"
                      no-resize
                      height="175px"
                      v-model="editItem.additional_feedback"
                      @click="surveyChanged=true">
                    </v-textarea>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="editItem.rating === '1' || editItem.rating === '2'">
                    <div class="pr-4 pl-5 mt-4 v-label theme--light">
                      We apologize for not meeting your expectations. Your opinion is very valuable to us.
                      Please let us know how we can improve the service or problems you ran into.
                    </div>
                    <v-textarea
                      outline
                      class="pr-4 pl-5 mt-3"
                      no-resize
                      height="175px"
                      v-model="editItem.satisfaction_feedback"
                      @click="surveyChanged=true">
                    </v-textarea>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <div class="pr-4 pl-5 mt-4 v-label theme--light">What part of the process was the  easiest or most helpful ?</div>
                    <v-textarea
                      outline
                      class="pr-4 pl-5 mt-3"
                      label="Easiest or helpful"
                      no-resize
                      height="175px"
                      v-model="editItem.comment"
                      @click="surveyChanged=true">
                    </v-textarea>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="editItem.rating === '1' || editItem.rating === '2'">
                    <v-radio-group class="pr-4 pl-5" v-model="isContact" label="Would you like someone to contact you ?" column>
                      <v-radio label="Yes" color="success" value="Yes"></v-radio>
                      <v-radio label="No" color="success" value="No"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="(editItem.rating === '1' || editItem.rating === '2') && isContact === 'Yes'">
                    <v-menu
                      v-model="date.picker"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="FormattedDate"
                          :label="date.label"
                          hint="MM/DD/YYYY"
                          persistent-hint
                          readonly
                          clearable
                          prepend-icon="event"
                          @blur="editItem.contact.date = parseDate(FormattedDate); surveyChanged = true"
                          v-on="on"
                          class="pr-4 pl-4"
                          @input="isFormDataChanged = true; surveyChanged = true"
                        ></v-text-field>
                      </template>
                      <v-date-picker :min="new Date().toISOString().substr(0, 10)" v-model="editItem.contact.date" @input="date.picker = false"></v-date-picker>
                    </v-menu>
                    <v-menu
                      ref="menu"
                      v-model="time.picker"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="time"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="editItem.contact.time"
                          class="pr-4 pl-4"
                          :label="time.label"
                          prepend-icon="access_time"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-model="time.value"
                        full-width
                        @click:minute="time.picker = false"
                      ></v-time-picker>
                    </v-menu>
                    <v-text-field
                      prepend-icon="star"
                      v-mask="'(###) ###-####'"
                      label="Phone Number" 
                      v-model="editItem.contact.phone"
                      @input="surveyChanged=true"
                      :rules="rules.phone"
                      class="pr-4 pl-4">
                    </v-text-field>
                  </v-flex>
              </v-layout>
              </v-form>
              <v-layout class="pr-4 pl-4">
                <v-flex xs12 sm12 md12 class="pr-0">
                  <div class="text-xs-right" v-if="surveyChanged">
                    <v-btn class="pf-btn pf-btn-cancel" @click="cancelEdit">
                      <v-icon size="16" class="pr-1">cancel</v-icon>
                      <div>Cancel</div>
                    </v-btn>
                    <v-btn class="pf-btn pf-btn-save" @click="updateSurvey">
                      <v-icon size="16" class="pr-1">check_circle</v-icon>
                      <div>Submit</div>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-layout> -->
            <!-- <v-card v-else class="mt-3"> -->
            <v-card class="mt-3">
              <v-data-table
                disable-initial-sort
                :headers="surveyHeaders"
                :items="surveys"
                :search="surveySearch"
                :pagination.sync="surveyPagination"
                class="pf-data-table"
              >
                <template v-slot:items="props">
                  <td>{{ props.index + 1 }}</td>
                  <td>{{ getRating(props.item.rating) }}</td>
                  <td>{{ props.item.comment }}</td>
                  <td>
                    <v-select
                      v-model="props.item.status"
                      :items="surveyStatusList"
                      height="30px"
                      @change="surveyStatusUpdate(props.item)"
                    ></v-select>
                  </td>
                  <!-- <td align="right">
                    <v-btn icon class="ma-0" @click="editSurvey(props.item)">
                      <v-icon size="22" color="grey darken-2">edit</v-icon>
                    </v-btn>
                    <v-btn icon class="ma-0" @click="deleteSurvey(props.item)">
                      <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                    </v-btn>
                  </td> -->
                </template>
              </v-data-table>
            </v-card>
          </v-layout>
          <!-- Add survey -->
          <!-- <v-layout v-else class="flex-column">
            <v-btn fab left @click="isAddSurvey = false" class="pf-btn-fab">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-layout class="pr-4 pl-4">
              <v-flex xs12 sm12 md12 class="pr-0">
                <div class="text-xs-right" v-if="surveyChanged">
                  <v-btn class="pf-btn pf-btn-cancel" @click="isAddSurvey = false">
                    <v-icon size="16" class="pr-1">cancel</v-icon>
                    <div>Cancel</div>
                  </v-btn>
                  <v-btn class="pf-btn pf-btn-save" @click="addSurvey">
                    <v-icon size="16" class="pr-1">check_circle</v-icon>
                    <div>Submit</div>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
            <v-form ref="addSurveyForm">
              <v-layout wrap class="pb-4 pt-3">
                <v-flex xs12 sm6>
                  <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="survey.explained_clearly" label="Was the profile process explained to you clearly ?" column>
                    <v-radio label="Yes" color="success" value="Yes"></v-radio>
                    <v-radio label="No" color="success" value="No"></v-radio>
                    <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="survey.meeting_ontime" label="Did your meeting start on the communicated date and time ?" column>
                    <v-radio label="Yes" color="success" value="Yes"></v-radio>
                    <v-radio label="No" color="success" value="No"></v-radio>
                    <v-radio label="No - but it was due to our conflict" color="success" value="No - but it was due to our conflict"></v-radio>
                    <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="survey.helpful" label="Was the person that you worked with helpful in creating your profile ?" column>
                    <v-radio label="Yes" color="success" value="Yes"></v-radio>
                    <v-radio label="No" color="success" value="No"></v-radio>
                    <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-radio-group class="pr-4 pl-5" v-model="survey.communicate_clearly" label="Did the person that worked with you on your profile communicate clearly ?" column>
                    <v-radio label="Yes" color="success" value="Yes"></v-radio>
                    <v-radio label="No" color="success" value="No"></v-radio>
                    <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="survey.overall_timelines" label="Were overall timelines communicated to you ?" column>
                    <v-radio label="Yes" color="success" value="Yes"></v-radio>
                    <v-radio label="No" color="success" value="No"></v-radio>
                    <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="survey.meet_timelines" label="Did we meet the timelines ?" column>
                    <v-radio label="Yes" color="success" value="Yes"></v-radio>
                    <v-radio label="No" color="success" value="No"></v-radio>
                    <v-radio label="No, because of our delay" color="success" value="No, because of our delay"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="survey.rating" label="Overall satisfaction with profile creation process ?" column>
                    <v-radio label="Wow it has been great !" color="success" value="5"></v-radio>
                    <v-radio label="Very satisfied" color="success" value="4"></v-radio>
                    <v-radio label="Satisfied" color="success" value="3"></v-radio>
                    <v-radio label="Slightly satisfied" color="success" value="2"></v-radio>
                    <v-radio label="Not satisfied" color="success" value="1"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm6>
                  <div class="pr-4 pl-5 mt-4 v-label theme--light">Additional Feedback:</div>
                  <v-textarea
                    outline
                    class="pr-4 pl-5 mt-3"
                    label="Your feedback"
                    no-resize
                    height="175px"
                    v-model="survey.additional_feedback"
                    @click="surveyChanged=true">
                  </v-textarea>
                </v-flex>
                <v-flex xs12 sm6 v-if="survey.rating === '1' || survey.rating === '2'">
                  <div class="pr-4 pl-5 mt-4 v-label theme--light">
                    We apologize for not meeting your expectations. Your opinion is very valuable to us.
                    Please let us know how we can improve the service or problems you ran into.
                  </div>
                  <v-textarea
                    outline
                    class="pr-4 pl-5 mt-3"
                    no-resize
                    height="175px"
                    v-model="survey.satisfaction_feedback"
                    @click="surveyChanged=true">
                  </v-textarea>
                </v-flex>
                <v-flex xs12 sm6>
                  <div class="pr-4 pl-5 mt-4 v-label theme--light">What part of the process was the  easiest or most helpful ?</div>
                  <v-textarea
                    outline
                    class="pr-4 pl-5 mt-3"
                    label="Easiest or helpful"
                    no-resize
                    height="175px"
                    v-model="survey.comment"
                    @click="surveyChanged=true">
                  </v-textarea>
                </v-flex>
                <v-flex xs12 sm6 v-if="survey.rating === '1' || survey.rating === '2'">
                  <v-radio-group class="pr-4 pl-5" v-model="isContact" label="Would you like someone to contact you ?" column>
                    <v-radio label="Yes" color="success" value="Yes"></v-radio>
                    <v-radio label="No" color="success" value="No"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm6 v-if="(survey.rating === '1' || survey.rating === '2') && isContact === 'Yes'">
                  <v-menu
                    v-model="date.picker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="FormattedDate"
                        :label="date.label"
                        hint="MM/DD/YYYY"
                        persistent-hint
                        readonly
                        clearable
                        prepend-icon="event"
                        @blur="survey.contact.date = parseDate(FormattedDate); surveyChanged = true"
                        v-on="on"
                        class="pr-4 pl-4"
                        @input="isFormDataChanged = true; surveyChanged = true"
                      ></v-text-field>
                    </template>
                    <v-date-picker :min="new Date().toISOString().substr(0, 10)" v-model="survey.contact.date" @input="date.picker = false"></v-date-picker>
                  </v-menu>
                  <v-menu
                    ref="menu"
                    v-model="time.picker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="survey.contact.time"
                        class="pr-4 pl-4"
                        :label="time.label"
                        prepend-icon="access_time"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-model="time.value"
                      full-width
                      @click:minute="time.picker = false"
                    ></v-time-picker>
                  </v-menu>
                  <v-text-field
                    prepend-icon="star"
                    v-mask="'(###) ###-####'"
                    label="Phone Number" 
                    v-model="survey.contact.phone"
                    @input="surveyChanged=true"
                    :rules="rules.phone"
                    class="pr-4 pl-4">
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
            <v-layout class="pr-4 pl-4">
              <v-flex xs12 sm12 md12 class="pr-0">
                <div class="text-xs-right" v-if="surveyChanged">
                  <v-btn class="pf-btn pf-btn-cancel" @click="isAddSurvey = false">
                    <v-icon size="16" class="pr-1">cancel</v-icon>
                    <div>Cancel</div>
                  </v-btn>
                  <v-btn class="pf-btn pf-btn-save" @click="addSurvey">
                    <v-icon size="16" class="pr-1">check_circle</v-icon>
                    <div>Submit</div>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-layout> -->
        </v-tab-item>

        <!-- Print -->
        <v-tab-item value="tab-7">
          <v-flex xs12 sm12 class="pl-2">
            <h5 class="text-uppercase font-weight-bold mb-3">Print</h5>
          </v-flex>
          <v-form ref="printOrderForm">

            <v-flex class="pl-2">
              <table class="pf-simple-table white-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Organization</th>
                    <th>Ordered</th>
                    <th>Tracking No.</th>
                    <th>Shipped</th>
                    <th>Shipping Address</th>
                    <th>Delivery</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, a) in taskDetailsObj.print_order" :key="a">
                    <template v-if="!order">
                      <td colspan="7">No records found</td>
                    </template>
                    <template v-else>
                      <td>{{ a + 1 }}</td>
                      <td>{{ accountObj.agency.findIndex(x => x.agency.id.toString() === order.agency.toString()) > -1 ? accountObj.agency[accountObj.agency.findIndex(x => x.agency.id.toString() === order.agency.toString())].agency.name : '--' }}</td>
                      
                      <td>
                        <VueCtkDateTimePicker button-now-translation="Today" auto-close color="#019d8c" class="" @input="editTaskDetails('print')" :only-date="true" format="YYYY-MM-DD" label="" formatted="L" v-model="order.ordered_date" />
                      </td>

                      <td>
                        <v-text-field :disabled="!order.ordered_date" v-model="order.tracking_number" class="date-filter" @change="editTaskDetails('print')"></v-text-field>
                      </td>

                      <td>
                        <VueCtkDateTimePicker button-now-translation="Today" :disabled="!order.ordered_date" auto-close color="#019d8c" class="" @input="editTaskDetails('print')" :only-date="true" format="YYYY-MM-DD" label="" formatted="L" v-model="order.shipped_date" />
                      </td>


                      <td>
                        <v-textarea :disabled="!order.shipped_date" v-model="order.ship_to_address" rows="4" class="inner-textarea" @change="editTaskDetails('print')"></v-textarea>
                      </td>

                      <td>
                        <VueCtkDateTimePicker button-now-translation="Today" :disabled="!order.shipped_date" auto-close color="#019d8c" class="" @input="editTaskDetails('print')" :only-date="true" format="YYYY-MM-DD" label="" formatted="L" v-model="order.delivery_date" />
                      </td>

                    </template>
                  </tr>
                </tbody>
              </table>
            </v-flex>

          </v-form>
        </v-tab-item>

      </v-tabs>

    </v-container>
  </div>
</template>
<script>

/* global session store moment config */
import Vue from 'vue';
import swal from 'sweetalert2';
import { update, getCollection, getOne, create, formatDate, uploadFile, remove, request, requestExternal } from '../helpers/helpers';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import UploadButton from 'vuetify-upload-button';
import { saveAs } from 'file-saver';
import { mask } from 'vue-the-mask';
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

export default {
  name: 'AccountInformation',
  directives: { mask },
  components: {
    'upload-btn': UploadButton,
  }, 
  data: vm => ({
    config: config,
    tabsModel: 'tab-1',
    accountId: null,
    accountObj: {},
    submitting_clips_via_list: [
      { text: '--select--', value: '' },
      'None',
      'Dropbox',
      'USB',
      'PF video camera',
    ],
    submitting_photos_via_list: [
      { text: '--select--', value: '' },
      'None',
      'Dropbox',
      'USB',
      'Album in parent finder',
    ],
    writersList: [
      // { name: '--select--', human: [{ id: '' }] },
    ],
    isFormDataChanged: false,
    taskDetailsObj: {
      first_meeting: {
        // is_done: false,
        date: null
      },
      // writing_coach: '',
      // template: '',
      // themes: [],
      // important_notes: '',
      settings: {
        writing_reminder_date: false,
        // text_completed: false,
        // text_approved: false,
        // received_photos: false,
        // profile_sent: false,
        // sent_first_proof: false,
        // pdf_flipbook_epub_uploaded: false,
        // is_profile_complete: false,
        pdf_flipbook_epub_uploaded_date: null
      },
      // profile_proof: {
      //   approved: false,
      //   approved_date: null
      // },
      // featured_social_media: {
      //   is_done: false,
      //   featured_date: null
      // },
      social_media: {
        // dont_feature: false,
        pf_featured_date: null,
        // is_family_want: false,
        // implemented_date: null
      },
      website: {
        // is_live: false,
        // url_ordered_date: null,
        live_date: null
      },
      // blurb_book: {
      //   is_ordered: false,
      //   estimated_delivery: null
      // },
      // printed_profiles: {
      //   tracking_number: '',
      //   ship_to_address: '',
      //   delivery_date: null,
      //   ordered_date: null,
      //   shipped_date: null
      // },
      print_order: [],
      // video_order_form: {
      //   is_sent: false,
      //   camera_form_sent: null // Date Time field
      // },
      // video_camera: {
      //   ordered_date: null,
      //   shipped_date: null,
      //   tracking_number: '',
      //   tracking_number_entered: false,
      //   video_production_number: '',
      //   received_back_date: null,
      //   entered_camera_received: false
      // },
      video_profile: {
        sent_for_approval_date: null,
        // is_approved: false,
        // approved_date: null,
        // submitting_clips_via: '',
        // submitted_all_videos: false,
        // submitting_photos_via: '',
        // submitted_all_photos: false
      },
      survey: {
        is_sent: false,
        sent_date: null, // Date Time field
        // is_received: false,
        received_date: null // Date Time field
      },
      notes: []
    },
    task_details_settings: {
      first_meeting: true,
      writing_coach: true,
      writing_reminder: true,
      text_completed: true,
      text_approved: true,
      received_photos: true,
      template_choice: true,
      themes: true,
      profile_sent_layout: true,
      sent_first_proof: true,
      video_order_form: true,
      survey_sent: true,
      survey_received: true,
      pdf_flipbook_epub_uploaded: true,
      camera_ordered: true,
      camera_shipped: true,
      camera_tracking_no: true,
      video_production_no: true,
      submitted_photos: true,
      submitted_videos: true,
      website_live: true,
      profile_complete: true,
      profile_proof_approved: true,
      featured_in_social_media: true,
      blurb_book_ordered: true,
      blurb_book_delivery: true,
      printed_profiles_ordered: true,
      printed_profile_tracking_no: true,
      profiles_shipping: true,
      profiles_ship_address: true,
      printed_profiles_delivery_date: true,
      video_camera_received: true,
      entered_video_camera_received: true,
      video_profile_sent_approval: true,
      video_profile_approved: true,
      video_profile_submitted_all_videos: true,
      video_profile_submitted_all_photos: true,
      wants_social_media: true,
      done_social_media: true,
      url_ordered: true,
      submit_videos_via: true,
      submit_photos_via: true,
      notes: true
    },
    joinedDateMenu: false,
    isAccountInfoChanged: false,
    isContactInfoChanged: false,
    profileStatusList: ['New', 'Open', 'Layout', 'Video', 'Writing'],
    statusList: ['Active', 'Approved', 'Inactive', 'In Progress', 'Pending', 'Rejected', 'Suspended'],
    rules: {
      email: [
        v => !!v || 'Email address is required',
        v => !!v || /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(v) || 'Please enter a valid email address'
      ],
      phone: [
        v => !!v || 'Phone number is required',
        v => v !== undefined || v !== '' || /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number'
      ],
      secEmail: [
        v => (!v || v === '' || /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(v)) || 'Please enter a valid email address',
      ],
      secPhone: [
        v => (v === undefined || v === '') || /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number'
      ],
      required: value => !!value || 'This field is mandatory.',

      URLRules: (v) => v === '' || /^$|(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g.test(v) || 'Please enter valid URL Address',
      facebookRule: (v) => v === '' || /^(https?:\/\/)?(www\.)?facebook.com\/[a-zA-Z0-9(\.\?)?]/g.test(v) || 'Please enter a valid facebook link',
      googleRule: (v) => v === '' || /^(https?:\/\/)?(www\.)?plus.google.com\/[a-zA-Z0-9(\.\?)?]/g.test(v) || 'Please enter a valid google plus link',
      ticktokRule: (v) => v === '' || /^(https?:\/\/)?(www\.)?tiktok.com\/[a-zA-Z0-9(\.\?)?]/g.test(v) || 'Please enter a valid tiktok link',
      twitterRule: (v) => v === '' || /^(https?:\/\/)?(www\.)?twitter.com\/[a-zA-Z0-9(\.\?)?]/g.test(v) || 'Please enter a valid twitter link',
      bloggerRule: (v) => v === '' || /^(https?:\/\/)?(www\.)?blogger.com\/[a-zA-Z0-9(\.\?)?]/g.test(v) || 'Please enter a valid blogger link',
      instagramRule: (v) => v === '' || /^(https?:\/\/)?(www\.)?instagram.com\/[a-zA-Z0-9(\.\?)?]/g.test(v) || 'Please enter a valid instagram link',
      pintrestRule: (v) => v === '' || /^(https?:\/\/)?(www\.)?pinterest.com\/[a-zA-Z0-9(\.\?)?]/g.test(v) || 'Please enter a valid pinterest link',
      validLink: async (v) => v === '' || await vm.verifyURL(v) || 'This URL does not exists'
    },
    isAddAgency: false,
    newAgencies: [],

    selectTitle: 'Select file(s)',
    dialog: false,
    DialogImg: '',
    editMode: false,
    notesHeaders: [
      { text: 'Date / Time', value: 'createdAt' },
      { text: 'Person', value: 'createdBy.human.name' },
      { text: 'Title', value: 'title' },
      { text: 'Tagged to', value: 'human' },
      // { text: 'Note', value: 'note' },
      // { text: 'Files', align: 'left' },
      { text: 'Actions', sortable: false, align: 'right' },
    ],
    adminTags: [],
    adminList: [],
    IssueList: [
      'Yes',
      'No',
    ],
    notesPagination: {
      sortBy: 'createdAt', // The field that you're sorting by
      descending: true,
      rowsPerPage: config.dom.rowsPerPage,
    },
    notesList: [],
    // selectList: ['Recent First', 'Recent Last'],
    searchNotes: '',
    editableIndex: -1,
    editableNoteObj: {},

    AddNewNotes: {
      note: '',
      title: '',
      issue: 'No'
    },
    uploadingFile: [],
    isAddNote: false,

    videoProjects: [],
    profileDocument: {},
    projectVideo: {},
    surveys: [],
    surveyPagination: {
      sortBy: 'createdAt', // The field that you're sorting by
      descending: true,
      rowsPerPage: config.dom.rowsPerPage
    },
    surveyStatusList: ['Pending', 'Approved', 'Rejected'],
    surveyHeaders: [
      { text: '#' },
      { text: 'Rating', value: 'rating', width: '160px' },
      { text: 'Comment', value: 'comment', width: '350px', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      // { text: '', width: '160px', sortable: false }
    ],
    surveySearch: '',
    ratingOptions: [
      { text: 'Wow it has been great !', value: 5 },
      { text: 'Very satisfied', value: 4 },
      { text: 'Satisfied', value: 3 },
      { text: 'Slightly satisfied', value: 2 },
      { text: 'Not satisfied', value: 1 }
    ],
    isAddSurvey: false,
    required: [
      v => !!v || 'This option is required',
    ],
    surveyChanged: false,
    survey: {
      explained_clearly: null,
      meeting_ontime: null,
      helpful: null,
      communicate_clearly: '',
      overall_timelines: null,
      meet_timelines: null,
      comment: '',
      rating: null,
      additional_feedback: '',
      satisfaction_feedback: '',
      contact: {
        date: null,
        time: null,
        phone: null
      }
    },
    FormattedDate: null,
    isContact: '',
    date: {
      label: 'Date',
      value: null,
      picker: false
    },
    time: {
      label: 'Time',
      picker: false
    },
    editIndex: -1,
    editItem: null,
    currentDateFields: [],
    dateFields: [
      { text: 'First meeting', type: 'Kickoff', name: 'firstMeeting' },
      // { text: 'Profile print ordered', type: 'Post Production', name: 'profilePrintOrdered' },
      // { text: 'Profile print ship date', type: 'Post Production', name: 'profilePrintShipDate' },
      // { text: 'Profile print delivery date', type: 'Post Production', name: 'profilePrintDeliveryDate' },
      { text: 'PDF upload', type: 'Layout', name: 'PDFUpload' },
      { text: 'Flipbook generated', type: 'Layout', name: 'flipbookGenerated' },
      // { text: 'ePub generated', type: 'Layout', name: 'ePubGenerated' },
      { text: 'Video app download', type: 'Video', name: 'videoAppDownload' },
      { text: 'Video project submitted', type: 'Video', name: 'videoProjectSubmitted' },
      { text: 'Video sent for approval', type: 'Video', name: 'videoSentForApproval' },
      { text: 'Video profile approval date', type: 'Video', name: 'videoProfileApprovalDate' },
      { text: 'Writing reminder sent to parent', type: 'Writing', name: 'writingReminderSentToParent' },
      { text: 'Writing tool access date', type: 'Writing', name: 'writingToolAccessDate' },
      { text: 'Text approved', type: 'Writing', name: 'textApproved' },
      { text: 'Profile sent to layout', type: 'Writing', name: 'profileSentToLayout' },
      { text: 'First proof sent', type: 'Writing', name: 'firstProofSent' },
      { text: 'Satisfaction survey sent', type: 'Survey', name: 'satisfactionSurveySent' },
      { text: 'Satisfaction survey received', type: 'Survey', name: 'satisfactionSurveyReceived' },
      { text: 'Profile proof approved', type: 'Layout', name: 'profileProofApproved' },
      { text: 'Profile completion', type: 'Layout', name: 'profileCompletion' },
      { text: 'Date featured in PF social media', type: 'Social', name: 'featuredInPFSocialMedia' },
      { text: 'Parent\'s website is live on', type: 'Profile', name: 'websiteLiveOn' }
    ],
    filterDateCategory: 'All',
    dateFilterTypes: ['Kickoff', /* 'Post Production', */ 'Layout', 'Video', 'Writing', 'Survey', 'Social', 'Profile'],
    designersList: [],
    userData: null,
    isPrintDataChanged: false,
    viewNoteObj: null,
    socialAccounts: {
      facebook: { url: '', active: true },
      tiktok: { url: '', active: true },
      twitter: { url: '', active: true },
      blogger: { url: '', active: true },
      instagram: { url: '', active: true },
      pinterest: { url: '', active: true }
    },
    activeStatuses: ['Active', 'Approved']
  }),
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    },
    templateList: {
      get () {
        return store.state.Template;
      },
      set (value) {
        store.commit('setTemplate', value);
      }
    },
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
    firstProofDate () {
      let parentReviewIndex = this.profileDocument.pdf && this.profileDocument.pdf.review_history && this.profileDocument.pdf.review_history.length ? this.profileDocument.pdf.review_history.findIndex(x => x.status === 'ParentReview') : -1;
      if (parentReviewIndex > -1) {
        return this.profileDocument.pdf.review_history[parentReviewIndex].status_date ? this.formatDateString(this.profileDocument.pdf.review_history[parentReviewIndex].status_date, 'LL') : '--';
      }
      return '--';
    },
    profileProofApprovedDate () {
      let parentReviewIndex = this.profileDocument.pdf && this.profileDocument.pdf.review_history && this.profileDocument.pdf.review_history.length ? this.profileDocument.pdf.review_history.findIndex(x => x.status === 'Approved') : -1;
      if (parentReviewIndex > -1) {
        return this.profileDocument.pdf.review_history[parentReviewIndex].status_date ? this.formatDateString(this.profileDocument.pdf.review_history[parentReviewIndex].status_date, 'LL') : '--';
      }
      return '--';
    },
    videoAppDownloadDate () {
      if (this.userData && this.userData.access && this.userData.access.length) {
        let firstMobileAccess = this.userData.access.find(x => x.device_info && Object.keys(x.device_info).length);
        if (firstMobileAccess && firstMobileAccess.date) {
          return this.formatDateString(firstMobileAccess.date, 'LL');
        }
      }
      return '--';
    },
    addableAgencies () {
      return this.AgencyList.filter(agency => agency && agency.id && this.accountObj.agency && this.accountObj.agency.findIndex(x => x.agency && x.agency.id.toString() === agency.id.toString()) === -1);
    },
    getFlipbookURL () {
      /* eslint-disable */
      let defaultAgencyIndex = this.accountObj.default_agency && this.accountObj.flipbook && this.accountObj.flipbook.length ? this.accountObj.flipbook.findIndex(x => x.agency === this.accountObj.default_agency.id) : -1;
      if (defaultAgencyIndex > -1) {
        return config.uploadPath + this.accountObj.flipbook[defaultAgencyIndex].flipbook;
      } else if (this.accountObj.flipbook && this.accountObj.flipbook.length) {
        /* Return the first flipbook */
        return this.accountObj.flipbook[0] && this.accountObj.flipbook[0].flipbook ? (config.uploadPath + this.accountObj.flipbook[0].flipbook) : null;
      }
      return null;
    },
    getFamilyBadgeURL () {
      /* eslint-disable */
      let URL = this.accountObj._id ? config.WPParams.host + 'view-our-families/#/profile/' + this.accountObj._id : null;
      return URL ? (URL.indexOf('http') > -1 ? URL : ('https://' + URL)) : null;
    },
    getFamilyURL () {
      /* eslint-disable */
      let URL = this.accountObj.contactInfo && this.accountObj.contactInfo.website ? this.accountObj.contactInfo.website : null;
      return URL ? (URL.indexOf('http') > -1 ? URL : ('https://' + URL)) : null;
    },
  },
  watch: {
    survey: {
      handler: function (after, before) {
        this.surveyChanged = true;
        if (after.contact) {
          this.FormattedDate = this.formatDateSpecial((after.contact.date));
        }
      },
      deep: true
    },
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  async created () {

    this.currentDateFields = this.dateFields;
    
    if (this.Agency.task_details_settings !== undefined) {
      this.task_details_settings = JSON.parse(JSON.stringify(this.Agency.task_details_settings));
    }
    /* Add task_details_settings.text_completed if not there - Newly added */
    // if (typeof this.task_details_settings.text_completed === 'undefined') {
    //   this.task_details_settings.text_completed = true;
    // }

    this.accountId = this.$route.params && this.$route.params.account ? this.$route.params.account : null;
    if (!this.accountId) {
      this.$router.push({ path: '/admin/families' });
    } else {
      await this.getAccount();
      if (this.accountObj.task_details) {
        this.taskDetailsObj = JSON.parse(JSON.stringify(this.accountObj.task_details));
      }

      if (!this.taskDetailsObj.print_order) {
        this.taskDetailsObj.print_order = [];
      }
      /* loop through the agency and add missing agencies to print_order */
      this.accountObj.agency.forEach(agency => {
        let agencyIndex = this.taskDetailsObj.print_order.findIndex(x => x.agency.toString() === agency.agency.id.toString());
        if (agencyIndex === -1) {
          this.taskDetailsObj.print_order.push({
            agency: agency.agency.id,
            tracking_number: '',
            ship_to_address: '',
            delivery_date: null,
            ordered_date: null,
            shipped_date: null
          });
        }
      });


      if (this.accountObj.ppn) {
        window.getApp.$emit('pageSubHeader', this.accountObj.ppn);
      }
      
      /* Add settings.text_completed if not there - Newly added */
      // if (typeof this.taskDetailsObj.settings.text_completed === 'undefined') {
      //   this.taskDetailsObj.settings.text_completed = false;
      // }

      // if (this.accountObj && this.accountObj.template && this.accountObj.template.template) {
      //   this.taskDetailsObj.themes.push(this.accountObj.template.template.name);
      //   this.taskDetailsObj.template = this.accountObj.template.template.name ? this.accountObj.template.template.name : '';
      // } else {
      //   this.taskDetailsObj.template = '';
      // }
      await this.initializeTemplates();
      await this.fetchWritersList();

      await this.getNotes();
      await this.getAdmins();
      await this.getVideoProject();
      await this.loadProfileDocument();
      await this.loadProjectVideo();
      await this.loadSurveys();
      await this.fetchDesignersList();
      await this.getUserAccess();
      this.setProfileURLs();
    }
    this.initializeAgencyList();
    this.getAdminSettings();

    /* Handle the route parameters */
    const params = this.$route.query;
    if (params) {
      if (params.section && 'notes' === params.section) {
        this.tabsModel = 'tab-5';
      } else if (params.section === 'addNote') {
        this.addNote();
      }
    }
    
  },
  methods: {
    isFormDataChange (e) {
      this.isFormDataChanged = true;
    },
    async initializeAgencyList () {
      if (!this.AgencyList.length) {
        let where = { _id: { $ne: this.Agency.id }, is_admin: false };
        let attributes = 'name,nickname,email,createdAt,_id,mapping_id';
        let populate = [{ path: 'human', select: '_id user' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes, null, { name: 1 });
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            store.commit('setAgencyList', data);
          }
        }
      }
    },
    async verifyURL (url) {
      if (url && /^$|(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g.test(url)) {
        try {
          await requestExternal(url, 'GET');
          return true;
        } catch (e) {
          return false;
        }
      }
      return false;
    },
    async setDefaultContact (item) {
      let accountData = JSON.parse(JSON.stringify(this.accountObj));
      accountData.default_agency = item.id;
      accountData.updated_from = 'default';
      accountData = this.formatAccountDoc(accountData);
      let { error, data, status } = await update('Account', accountData, this.accountId);
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to update data'
        };
      } else {
        this.accountObj.default_agency = {
          id: item.id,
          name: item.name
        };
      }
    },
    changeAccountType (accountType) {
      this.isAccountInfoChanged = true;
      if (accountType === 'Couple') {
        if (this.accountObj.human.length === 1) {
          this.accountObj.human.push({
            birth_date: '',
            education: '',
            ethnicity: '',
            first_name: '',
            gender: 'Unknown',
            last_name: '',
            occupation: '',
            religion: ''
          });
        } else {
          this.accountObj.human[1].birth_date = (this.accountObj.human[1].birth_date).substr(0, 10);
        }
      }
    },
    setProfileURLs () {
      if (this.accountObj) {
        this.socialAccounts = {
          facebook: this.accountObj.social && this.accountObj.social.facebook ? this.accountObj.social.facebook : { url: '', active: true },
          tiktok: this.accountObj.social && this.accountObj.social.tiktok ? this.accountObj.social.tiktok : { url: '', active: true },
          twitter: this.accountObj.social && this.accountObj.social.twitter ? this.accountObj.social.twitter : { url: '', active: true },
          blogger: this.accountObj.social && this.accountObj.social.blogger ? this.accountObj.social.blogger : { url: '', active: true },
          instagram: this.accountObj.social && this.accountObj.social.instagram ? this.accountObj.social.instagram : { url: '', active: true },
          pinterest: this.accountObj.social && this.accountObj.social.pinterest ? this.accountObj.social.pinterest : { url: '', active: true },
        };
      }
    },
    async saveURLs () {
      if (this.$refs.profileURLForm.validate()) {
        let accountData = JSON.parse(JSON.stringify(this.accountObj));
        accountData.social = this.socialAccounts;
        accountData.updated_from = 'socialMedia';
        accountData = this.formatAccountDoc(accountData);
        let { error, data, status } = await update('Account', accountData, this.accountId);
        if (error) {
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to update URLs'
          };
        }
      }
    },
    async getAdminSettings () {
      let where = { is_super_admin: true };
      let attributes = 'account_settings';
      let { error, data } = await getCollection('Agency', true, 0, '', where, attributes);
      if (error) {
        console.log(error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to load account settings'
        };
      } else {
        if (data.length > 0) {
          this.profileStatusList = data[0] && data[0].account_settings && data[0].account_settings.statuses && data[0].account_settings.statuses.length ? data[0].account_settings.statuses : this.profileStatusList;
        }
      }
    },
    async hideButtons () {
      this.isFormDataChanged = false;
      await this.getAccount();
      if (this.accountObj.task_details) {
        this.taskDetailsObj = JSON.parse(JSON.stringify(this.accountObj.task_details));
      }
    },
    async save () {
      if (this.isFormDataChanged && this.$refs.taskDetailsForm.validate()) {
        this.taskDetailsObj.account = this.accountId;
        let { error, data, status } = await create('TaskDetail', this.taskDetailsObj);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.taskDetailsObj = data;
          this.isFormDataChanged = false;
        }
      }
    },
    async editTaskDetails (from = null) {
      let form = from && from === 'print' ? 'printOrderForm' : 'taskDetailsForm';
      if (this.$refs[form].validate()) {
        let { error, data, status } = await update('TaskDetail', this.taskDetailsObj, this.taskDetailsObj.id);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.taskDetailsObj = data;
          // swal.fire({
          //   type: 'success',
          //   title: 'Task Detail updated successfully',
          //   showConfirmButton: false,
          //   timer: 2500,
          //   onClose: () => {
          //     this.isFormDataChanged = false;
          //   }
          // });
        }
      }
    },
    async initializeTemplates () {
      if (!this.templateList.length) {
        let { error, data } = await getCollection('Template', true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.templateList = data;
          }
        }
      }
    },
    async getAccount () {
      let populate = [
        { path: 'task_details' },
        { path: 'human', populate: { path: 'user', select: 'username' }},
        { path: 'default_agency', select: 'name' },
        { path: 'agency.agency', select: 'name' },
      ];
      // let populate = { path: 'task_details', populate: { path: 'notes.createdBy', select: 'human', populate: { path: 'human', select: 'first_name last_name' }}};
      let { error, data } = await getOne('Account', this.accountId, populate);
      if (error) {
        console.log(error);
      } else {
        this.accountObj = data;
        if (this.accountObj.task_details) {
          this.taskDetailsObj = JSON.parse(JSON.stringify(this.accountObj.task_details));
          if (this.accountObj.task_details && this.accountObj.task_details.notes) {
            this.notesList = this.accountObj.task_details.notes;
          }
        }
      }
    },
    async fetchWritersList () {
      let where = { is_writer: true };
      let sort = { 'name': -1 };
      let { error, data } = await getCollection('Agency', true, 0, '', where, null, null, sort);
      if (error) {
        console.log(error);
      } else if (data.length) {
        this.writersList = data;
      }
    },
    formatDateString (dateString, format = 'MM/DD/YYYY') {
      if (dateString) {
        return formatDate(dateString, format);
      }
    },
    parseDate (date) {
      if (!date) return '';
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    changeJoinDate (e) {
      this.accountObj.joined_date = new Date(e).toISOString();
      this.isAccountInfoChanged = true;
    },
    // eslint-disable-next-line
    async saveAccountInfo () {
      if (this.isAccountInfoChanged && this.$refs.accountInfoForm.validate()) {
        let isError = false;
        // let accountData = JSON.parse(JSON.stringify(this.accountObj));
        /* Update the human */
        /* if (accountData.human.length) {
          for (let h = 0; h < accountData.human.length; h++) {
            if (accountData.human[h] && accountData.human[h].id) {
              if (accountData.human[h].user && accountData.human[h].user.id) {
                accountData.human[h].user = accountData.human[h].user.id;
              }
              let { error, data, status } = await update('Human', accountData.human[h], accountData.human[h].id);
              if (error) {
                console.log('error', error);
                isError = true;
              }
            }
          }
        } */
        this.accountObj.human[0].ethnicity = this.accountObj.human[0].ethnicity || '';
        this.accountObj.human[0].education = this.accountObj.human[0].education || '';
        this.accountObj.human[0].religion = this.accountObj.human[0].religion || '';

        let updateData = JSON.parse(JSON.stringify(this.accountObj.human[0]));
        if (updateData.user && updateData.user.id) {
          updateData.user = updateData.user.id;
        }
        
        let { error, data, status } = await update('Human', updateData, this.accountObj.human[0].id);
        if (error) {
          console.log('error', error);
          isError = true;
        }

        if (this.accountObj.account_type === 'Single') {
          if (this.accountObj.human.length === 2) {

            let { error, data, status } = await remove('Human', this.accountObj.human[1].id);
            if (error) {
              console.log('error', error);
              isError = true;
            } else {
              this.accountObj.human.pop();
            }
          }
        } else if (this.accountObj.account_type === 'Couple') {
          if (this.accountObj.human.length === 2 && typeof this.accountObj.human[1].id !== 'undefined') {
            // Update the human[1]
            this.accountObj.human[1].ethnicity = this.accountObj.human[1].ethnicity || '';
            this.accountObj.human[1].education = this.accountObj.human[1].education || '';
            this.accountObj.human[1].religion = this.accountObj.human[1].religion || '';
            let updateData = JSON.parse(JSON.stringify(this.accountObj.human[1]));
            if (updateData.user && updateData.user.id) {
              updateData.user = updateData.user.id;
            }
            let { error, data, status } = await update('Human', updateData, this.accountObj.human[1].id);
            if (error) {
              console.log('error', error);
              isError = true;
            }
          } else {
            // Create the human[1]
            this.accountObj.human[1].ethnicity = this.accountObj.human[1].ethnicity || '';
            this.accountObj.human[1].education = this.accountObj.human[1].education || '';
            this.accountObj.human[1].religion = this.accountObj.human[1].religion || '';
            let { error, data, status } = await create('Human', this.accountObj.human[1]);
            if (error) {
              console.log('error', error);
              isError = true;
            } else {
              this.accountObj.human[1] = data;
            }
          }
        }

        // Update the account name:
        if (this.accountObj.account_type === 'Single') {
          this.accountObj.name = this.accountObj.human[0].first_name;
          if (this.accountObj.human[0].religion) this.accountObj.religion = [this.accountObj.human[0].religion];
        } else {
          if (this.accountObj.human[0].religion && this.accountObj.human[1].religion) this.accountObj.religion = [this.accountObj.human[0].religion, this.accountObj.human[1].religion];
          else if (this.accountObj.human[0].religion) this.accountObj.religion = [this.accountObj.human[0].religion];
          else if (this.accountObj.human[1].religion) this.accountObj.religion = [this.accountObj.human[1].religion];
          this.accountObj.name = `${this.accountObj.human[0].first_name} / ${this.accountObj.human[1].first_name}`;
        }

        let accountData = JSON.parse(JSON.stringify(this.accountObj));
        accountData = this.formatAccountDoc(accountData);
        
        accountData.updated_from = 'parentInfo';
        let accountUpdate = await update('Account', accountData, accountData.id);
        error = accountUpdate.error;
        data = accountUpdate.data;
        status = accountUpdate.status;

        if (error) {
          console.log('error', error);
          isError = true;
        }
        // Show the resultant response to the user
        if (isError) {
          this.isAccountInfoChanged = true;
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Unable to save your data, please try again.'
          };
        } else {
          this.isAccountInfoChanged = false;
        }
      }
    },
    formatAccountDoc (accountData) {
      if (!accountData) {
        return false;
      }
      if (this.accountObj.human && this.accountObj.human.length) {
        accountData.human = this.accountObj.human.map(x => x.id);
      }
      if (accountData.agency && accountData.agency.length) {
        accountData.agency = accountData.agency.filter(x => x.agency).map(x => {
          if (x.agency.id) {
            x.agency = x.agency.id;
          }
          return x;
        });
      }
      if (accountData.default_agency && accountData.default_agency.id) {
        accountData.default_agency = accountData.default_agency.id;
      }
      if (accountData.task_details && accountData.task_details.id) {
        accountData.task_details = accountData.task_details.id;
      }
      return accountData;
    },
    async saveContactInfo () {
      if (this.isContactInfoChanged && this.$refs.contactForm.validate()) {
        this.isContactInfoChanged = false;

        let updateData = JSON.parse(JSON.stringify(this.accountObj));
        updateData = this.formatAccountDoc(updateData);
        if (updateData.email && updateData.email.length) {
          updateData.email = [updateData.email];
        }
        if (updateData.phone && updateData.phone.length) {
          updateData.phone = [updateData.phone];
        }
        updateData.updated_from = 'contactInfo';
        let { error, data, status } = await update('Account', updateData, updateData.id);
        if (error) {
          this.isContactInfoChanged = true;
          console.log('error', error);
        } else {
          this.isContactInfoChanged = false;
          /* swal.fire({
            type: 'success',
            title: 'Contact information updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {}
          }); */
        }
      }
    },
    async duplicateEmailChecking (isSecondary = false) {
      if (!isSecondary && (!this.accountObj.contactInfo || !this.accountObj.contactInfo.email)) {
        return;
      }
      if (isSecondary && (!this.accountObj.email || !this.accountObj.email.length)) {
        return;
      }
      let checkEmail = isSecondary ? this.accountObj.email : this.accountObj.contactInfo.email;
      let where = { $or: [{ 'contactInfo.email': checkEmail }, { 'email': checkEmail }] };
      let { error, data } = await getCollection('Account', true, 0, '', where);
      if (error) {
        console.log(error);
      } else {
        if (data.length && this.accountObj.id !== data[0].id) {
          swal.fire({
            title: 'The entered email address already exists',
            type: 'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (isSecondary) {
              this.accountObj.email = '';
            } else {
              this.accountObj.contactInfo.email = '';              
            }
          });
        }
      }
    },
    async removeRequest (item) {
      let removeItem = JSON.parse(JSON.stringify(item));
      swal.fire({
        title: 'Are you sure?',
        text: "The family will be removed from this agency. You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, remove!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let agencyIndex = this.accountObj.agency.findIndex(agency => agency.agency && agency.agency.id.toString() === removeItem.agency.id.toString());
            if (agencyIndex === -1) {
              return;
            }
            let updateData = JSON.parse(JSON.stringify(this.accountObj));
            updateData.agency.splice(agencyIndex, 1);
            updateData = this.formatAccountDoc(updateData);

            let { error, data, status } = await update('Account', updateData, updateData.id);
            if (error) {
              console.log('error', error);
            } else {
              this.accountObj.agency.splice(agencyIndex, 1);
              let TimelineObj = {
                text: `Admin removed agency '${removeItem.agency.name}' from the list`,
                title: 'Removed Agency',
                account: updateData.id
              };
              let { TimelineError, timelineData } = await create('Timeline', TimelineObj);
              if (TimelineError) {
                console.log('error', TimelineError);
              }
              /* swal.fire(
                'Removed!',
                'The agency "' + removeItem.agency.name + '" has been removed for the family.',
                'success'
              ); */
            }
          })();
        }
      });
    },
    addNewAgency () {
      this.isAddAgency = true;
    },
    async submitNewAgencies () {
      let defaultStatus = 'Inactive';
      if (this.accountObj.default_agency && this.accountObj.default_agency.id && this.accountObj.agency && this.accountObj.agency.length) {
        let defaultIndex = this.accountObj.agency.findIndex(x => x.agency && x.agency.id.toString() === this.accountObj.default_agency.id.toString());
        if (defaultIndex > -1) {
          defaultStatus = this.accountObj.agency[defaultIndex].status || defaultStatus;
        }
      }
      for (let i = 0; i < this.newAgencies.length; i++) {
        let postData = {
          status: defaultStatus,
          agency: this.newAgencies[i],
          updateAt: new Date().toISOString()
        };
        let updateData = JSON.parse(JSON.stringify(this.accountObj));
        updateData = this.formatAccountDoc(updateData);

        updateData.agency.push(postData);
        updateData.updated_from = 'default';
        let { error, data, status } = await update('Account', updateData, updateData.id);
        if (error) {
          console.log('error', error);
        } else {
          // timeline update on agency request
          let agency = this.addableAgencies.find(agency => agency.id.toString() === this.newAgencies[i].toString());
          let TimelineObj = {
            text: `Profile added to the agency '${agency.name}'`,
            title: 'Agency Added',
            account: this.accountObj.id
          };

          let { TimelineError, timelineData } = await create('Timeline', TimelineObj);
          if (TimelineError) {
            console.log('error', TimelineError);
          }
          /* if (this.newAgencies.length === i + 1) {
            swal.fire({
              type: 'success',
              title: 'The family was added to the selected agencies',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {}
            });
          } */
        }
      }
      if (this.newAgencies.length) {
        this.isAddAgency = false;
        this.newAgencies = [];
        /* Refresh the account info */
        await this.getAccount();
      }
    },
    onCopySuccess () {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Copied to clipboard'
      };
    },
    async fileSelected (files, isAdd = false) {
      if (isAdd) {
        this.isFormDataChanged = true;
        this.uploadingFile = await files;
        this.title = `${this.uploadingFile.length} files selected`;
      } else {
        if (this.$refs.noteListForm.validate()) {
          this.newFileUpload(files);
        }
      }
    },
    async addNotesUpload () {
      if (this.$refs.addNotesForm.validate()) {
        let noteFiles = [];
        this.isFormDataChanged = false;
        let errorHtml = null;
        let files = this.uploadingFile;
        if (files.length !== 0) {
          for (let i = 0; i < files.length; i++) {
            if (files[i] !== 'undefined') {
              this.fileName = files[i].name;
              if (this.fileName.lastIndexOf('.') <= 0) {
                return;
              }
              if (files[i].size > this.config.uploadFileSize) {
                errorHtml = 'Maximum file upload size is ' + (this.config.uploadFileSize / 1024 / 1024) + ' MB';
              }
              if (errorHtml) {
                swal.fire({
                  title: `<strong>Upload Error</strong>`,
                  type: 'error',
                  html: errorHtml,
                  showCloseButton: true,
                  showCancelButton: false,
                  focusConfirm: false,
                  confirmButtonText: 'Close',
                });
                return;
              }
              window.getApp.$emit('AppProgress', true);
              const fr = new FileReader();
              fr.readAsDataURL(files[i]);
              fr.addEventListener('load', async () => {
                noteFiles.push(files[i]);
                if (i + 1 === files.length) {
                  this.addNoteApiCall(noteFiles);
                }
              });
            } 
          }
        } else {
          let postUrl = `Note/Upload`;
          let extraParams = {
            note: this.AddNewNotes.note,
            title: this.AddNewNotes.title,
            account: this.accountId,
            issue: this.AddNewNotes.issue || 'No'
          };
          if (this.adminTags.length) {
            extraParams.human = this.adminTags;
          }
          let response = await uploadFile(postUrl, null, 'POST', extraParams);
          if (!response.$data) {
            window.getApp.$emit('AppProgress', false);
            console.log('error', response.$error);
            this.snackbar = {
              show: true,
              color: 'red',
              text: response.$error
            };
          } else {
            await this.getNotes();
            this.addNotesCancel();
          }
        }
      }
    },
    addNote () {
      this.isAddNote = true;
      this.adminTags = [];
      this.tabsModel = 'tab-5';
    },
    cancelAddNote() {
      this.isFormDataChanged = false;
      this.isAddNote = false;
      this.editMode = false;
      this.AddNewNotes = {
        note: '',
        title: '',
        issue: 'No'
      };
    },
    async addNoteApiCall (noteFiles) {
      let postUrl = `Note/Upload`;
      let extraParams = {
        note: this.AddNewNotes.note,
        title: this.AddNewNotes.title,
        account: this.accountId,
        issue: this.AddNewNotes.issue || 'No'
      };
      if (this.adminTags.length) {
        extraParams.human = this.adminTags;
      }
      let response = await uploadFile(postUrl, noteFiles, 'POST', extraParams);
      if (!response.$data) {
        window.getApp.$emit('AppProgress', false);
        console.log('error', response.$error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: response.$error
        };
      } else {
        this.cancelAddNote();
        this.addNotesCancel();
      }
    },
    async newFileUpload (selectedfiles) {
      let noteFiles = [];
      this.selectedData = false;
      let errorHtml = null;
      let files = selectedfiles;
      if (files.length !== 0) {
        for (let i = 0; i < files.length; i++) {
          if (files[i] !== 'undefined') {
            this.fileName = files[i].name;
            if (this.fileName.lastIndexOf('.') <= 0) {
              return;
            }
            if (files[i].size > this.config.uploadFileSize) {
              errorHtml = 'Maximum file upload size is ' + (this.config.uploadFileSize / 1024 / 1024) + ' MB';
            }
            if (errorHtml) {
              swal.fire({
                title: `<strong>Upload Error</strong>`,
                type: 'error',
                html: errorHtml,
                showCloseButton: true,
                showCancelButton: false,
                focusConfirm: false,
                confirmButtonText: 'Close',
              });
              return;
            }
            window.getApp.$emit('AppProgress', true);
            const fr = new FileReader();
            fr.readAsDataURL(files[i]);
            fr.addEventListener('load', async () => {
              noteFiles.push(files[i]);
              if (i + 1 === files.length) {
                this.editNoteApiCall(noteFiles);
              }
            });
          } 
        }
      }
    },
    async editNoteApiCall (noteFiles) {
      let postUrl = `Note/${this.editableNoteObj.id}/Upload`;
      let response = await uploadFile(postUrl, noteFiles, 'PUT');
      if (!response.$data) {
        window.getApp.$emit('AppProgress', false);
        console.log('error', response.$error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: response.$error
        };
      } else {
        this.notesList[this.editableIndex] = response.$data;
        this.editableNoteObj = response.$data;
        this.title = this.editableNoteObj.files.length > 0 ? `${this.editableNoteObj.files.length} selected` : 'Select file(s)';
      }
    },
    async getNotes () {
      let where = { account: this.accountId };
      let { error, data } = await getCollection('Note', true, 0, '', where);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.notesList = data;
        }
      }
    },
    async getAdmins () {
      let where = { is_admin: true/* , recieve_message: true */ };
      let attributes = 'name,createdAt,_id';
      let populate = [{ path: 'human', select: '_id name user' }];
      let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
      if (error) {
        console.log(error);
      } else {
        if (data.length) {
          this.adminList = data.filter(x => x.human && x.human.length).map(x => {
            return { text: x.name, value: x.human[0].id }
          });
        }
      }
    },
    async getVideoProject () {
      let where = { account: this.accountId };
      let { error, data } = await getCollection('Project', true, 0, '', where);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.videoProjects = data;
        }
      }
    },
    async updateNote () {
      if (this.$refs.noteListForm.validate()) {
        let editableNotePayload = {
          title: this.editableNoteObj.title,
          note: this.editableNoteObj.note,
          account: this.accountId,
          files: this.editableNoteObj.files,
          issue: this.editableNoteObj.issue
        };
        if (this.adminTags.length) {
          editableNotePayload.human = this.adminTags;
        }
        let { error, data, status } = await update('Note', editableNotePayload, this.editableNoteObj.id);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Something went wrong, please try again.'
          };
        } else {
          this.notesList[this.editableIndex] = data;
          this.editableNoteObj = data;
          this.backToList();
        }
      }
    },
    async removeNoteFile (item) {
      if (this.$refs.noteListForm.validate()) {
        const index = this.editableNoteObj.files.indexOf(item);
        if (index >= 0) this.editableNoteObj.files.splice(index, 1);
        this.title = this.editableNoteObj.length > 0 ? `${this.editableNoteObj.length} selected` : 'Select file(s)';
        let editableNotePayload = {
          title: this.editableNoteObj.title,
          note: this.editableNoteObj.note,
          account: this.accountId,
          files: this.editableNoteObj.files,
          issue: this.editableNoteObj.issue
        };
        let { error, data, status } = await update('Note', editableNotePayload, this.editableNoteObj.id);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Something went wrong, please try again.'
          };
        } else {
          this.notesList[this.editableIndex] = data;
          this.editableNoteObj = data;
        }
      }
    },
    viewImage (imgUrl) {
      this.dialog = true;
      this.DialogImg = imgUrl;
    },
    async downloadImage (urlPath) {
      let filename = urlPath.substring(urlPath.lastIndexOf('/') + 1);
      saveAs(urlPath, filename);
    },
    async downloadFile (cdnPath) {
      let filename = cdnPath.substring(cdnPath.lastIndexOf('/') + 1);
      saveAs(cdnPath, filename);
    },
    deleteNotes (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove('Note', item.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this.notesList.indexOf(item);
              this.notesList.splice(index, 1);
              /* swal.fire(
                'Deleted!',
                `"${item.title}" has been deleted.`,
                'success'
              ); */
            }
          })();
        }
      });
    },
    async editNotes (item) {
      this.viewNoteObj = null;
      this.editMode = true;
      this.editableIndex = this.notesList.findIndex(note => note._id === item._id);
      this.editableNoteObj = JSON.parse(JSON.stringify(this.notesList[this.editableIndex]));
      this.title = this.editableNoteObj.files.length > 0 ? `${this.editableNoteObj.files.length} selected` : 'Select file(s)';
      this.adminTags = this.editableNoteObj.human || [];
    },
    async addNotesCancel () {
      this.cancelAddNote();
      this.editMode = false;
      this.editableNoteObj = {};
      this.editableIndex = -1;
    },
    // sortByDate () {
    //   this.notesPagination.descending = !this.notesPagination.descending;
    // },
    viewNote (item) {
      this.viewNoteObj = JSON.parse(JSON.stringify(item));
    },
    cancelViewNote () {
      this.viewNoteObj = null;
    },
    backToList () {
      window.getApp.$emit('pageSubHeader', '');
      this.editMode = false;
      this.editableNoteObj = {};
      this.editableIndex = -1;
    },

    async loadProjectVideo() {
      
      if (this.accountId) {
        let entity = "Video";
        let where = { account: this.accountId, is_project_final: true };
        let { error, data } = await getCollection(entity, true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.projectVideo = data[0];
          }
        }
      }
    },

    async loadSurveys () {
      if (this.accountId) {
        let sort = { 'createdAt': -1 };
        let where = { account: this.accountId, 'status': { '$in': ['Pending', 'Approved', 'Rejected'] }};
        let { error, data } = await getCollection('Survey', true, 0, '', where, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.surveys = data;
          }
        }
      }
    },

    async fetchDesignersList () {
      let where = { is_designer: true };
      let sort = { 'name': -1 };
      let { error, data } = await getCollection('Agency', true, 0, '', where, null, null, sort);
      if (error) {
        console.log(error);
      } else if (data.length) {
        this.designersList = data;
      }
    },

    async getUserAccess () {
      if (this.accountObj.human.length && this.accountObj.human[0].user) {
        let select = 'access';
        let { error, data } = await getOne('User', this.accountObj.human[0].user.id, '', select);
        if (error) {
          console.log(error);
        } else if (data) {
          this.userData = data;
        }
      }
    },

    getRating (ratingValue) {
      let result = this.ratingOptions.find(item => item.value === ratingValue);
      return result.text;
    },

    async addSurvey () {
      if (this.$refs.addSurveyForm.validate()) {
        if (!this.survey.communicate_clearly) {
          delete this.survey.communicate_clearly;
        }
        if (!this.survey.contact.phone) {
          delete this.survey.contact;
        } else if (this.survey.contact) {
          if (!this.survey.contact.date) {
            delete this.survey.contact.date;
          }
          if (!this.survey.contact.time) {
            delete this.survey.contact.time;
          }
        }
        this.survey.rating = Number(this.survey.rating);
        this.surveyChanged = false;

        this.survey.account = this.accountId;

        let { error, data } = await create('Survey', this.survey);

        if (error) {
          this.surveyChanged = true;
          console.log('error', error);

        } else {
          
          this.surveys.unshift(data);
          this.isAddSurvey = false;

          // swal.fire({
          //   type: 'success',
          //   title: 'Survey submitted successfully',
          //   showConfirmButton: false,
          //   timer: 2500
          // });
        }
      }
    },

    editSurvey (item) {
      this.editIndex = this.surveys.indexOf(item);
      this.editItem = JSON.parse(JSON.stringify(item));
      if (this.editItem.contact && this.editItem.contact.phone) {
        this.isContact = 'Yes';
      } else {
        this.editItem.contact = {
          date: '',
          time: '',
          phone: null
        };
      }
      if (this.editItem.contact && this.editItem.contact.date) {
        this.editItem.contact.date = (this.editItem.contact.date).substr(0, 10);
      }
      this.editItem.rating = `${this.editItem.rating}`;
    },

    cancelEdit () {
      this.editItem = null;
      this.editIndex = -1;
    },

    async updateSurvey () {
      if (this.$refs.editSurveyForm.validate()) {
        this.surveyChanged = false;
        this.editItem.rating = Number(this.editItem.rating);
        if (!this.editItem.contact.phone) {
          delete this.editItem.contact;
        } else if (this.editItem.contact) {
          if (!this.editItem.contact.date) {
            delete this.editItem.contact.date;
          }
          if (!this.editItem.contact.time) {
            delete this.editItem.contact.time;
          }
        }
        let postData = {
          account: this.accountId,
          explained_clearly: this.editItem.explained_clearly,
          meeting_ontime: this.editItem.meeting_ontime,
          helpful: this.editItem.helpful,
          communicate_clearly: this.editItem.communicate_clearly,
          overall_timelines: this.editItem.overall_timelines,
          meet_timelines: this.editItem.meet_timelines,
          rating: this.editItem.rating,
          comment: this.editItem.comment ? this.editItem.comment : '',
          contact: this.isContact === 'Yes' ? this.editItem.contact : {}
        };
        let { error, data } = await update('Survey', postData, this.editItem.id);
        if (error) {
          this.surveyChanged = true;
          console.log('error', error);
        } else {
          this.surveys[this.editIndex] = data;
          this.cancelEdit();
        }
      }
    },

    deleteSurvey (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove('Survey', item.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this.surveys.indexOf(item);
              this.surveys.splice(index, 1);
              /* swal.fire(
                'Deleted!',
                'The survey has been deleted.',
                'success'
              ); */
            }
          })();
        }
      });
    },

    async surveyStatusUpdate (item) {
      let updateItem = JSON.parse(JSON.stringify(item));
      updateItem.account = updateItem.account.id;
      let itemIndex = this.surveys.indexOf(item);
      let updateId = this.surveys[itemIndex].id;
      let { error, data, status } = await update('Survey', updateItem, updateId);
      if (error) {
        console.log('error', error);
        swal.fire({
          type: 'error',
          title: 'Failed to update data',
          showConfirmButton: true,
          timer: 2500,
          onClose: () => {}
        });
      }/*  else {
        swal.fire(
          'Updated!',
          'The survey status been updated.',
          'success'
        );
      } */
    },

    filterByDateCategory () {
      if (this.filterDateCategory) {
        this.currentDateFields = this.dateFields.filter(x => ['All', x.type].indexOf(this.filterDateCategory) > -1);
      }
    },

    formatDateSpecial (date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },

    async loadProfileDocument() {
      if (this.accountId && !Object.keys(this.profileDocument).length) {

        let entity = "ProfileDocument";
        // let select = "filename mimetype size original_url thumb_url webview_url caption";
        let populate = [
          // { path: "chapters.items.photo", select: select },
          // { path: "writer", select: 'human avatar name' },
          // { path: "special_pictures.front_cover.photo", select: select },
          // { path: "special_pictures.back_cover.photo", select: select },
          // { path: "special_pictures.center_spread.photo", select: select },
          // { path: "pdf.template", select: 'file' }
        ];
        let where = { account: this.accountId };
        let { error, data } = await getCollection(
          entity,
          true,
          0,
          populate,
          where
        );
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.profileDocument = data[0];

            /* Arrange based on sort value */
            // if (
            //   this.profileDocument.chapters &&
            //   this.profileDocument.chapters.length
            // ) {
            //   this.profileDocument.chapters.sort((a, b) => a.sort - b.sort);
            // }

          }
        }
      }
    },

    async updateProfileDocument() {

      let entity = "ProfileDocument";
      let updateData = JSON.parse(JSON.stringify(this.profileDocument));
      // updateData = await this.formatProfileDocument(updateData);

      updateData.request_from = 'changeWriter';

      let { error, data } = await update(entity, updateData, updateData.id);
      return { error, data };
    },
    async updateAccountStatus (newStatus, agency) {

      if (!agency || !agency.id) {
        return;
      }
      let payload = {
        account: this.accountObj.id,
        agency: agency.id,
        status: newStatus
      }
      let { error, data } = await request('Agency/StatusUpdate', 'POST', payload);
      if (error) {
        console.log('error', error);
      } else {
        swal.fire({
          type: "success",
          title: "Success",
          text: `The family status for the agency ${agency.name} was successfully changed into '${newStatus}'`,
          showConfirmButton: true
        });
      }

    }
    // async formatProfileDocument(data) {
    //   if (data.writer && data.writer.id) {
    //     data.writer = data.writer.id;
    //   }
    //   return data;
    // },
  }
};
</script>

<style lang="css" scoped>
  #taskDetails >>> .v-icon.material-icons.accent--text {
    color: #019d8c !important;
    caret-color:  #019d8c !important;
  }

  #taskDetails >>> .v-input__slot {
    flex-direction: row-reverse;
  }

  #taskDetails >>> .v-label.theme--light {
    width: 300px;
  }

 #taskDetails >>> .theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
   border: 1px solid rgba(0,0,0,.2);
 }

 .button-container{
    min-height: 60px;
  }
  .account-type{
    padding-top: 2px;
  }
  .switch-account{
    padding-top: 5px;
  }

  .switch-cover {
    cursor: pointer;
    float:left;
  }
  .switch-cover input {
      position: absolute;
      opacity: 0;
  }
  .checkmark {
      background-color: #eff0f4;
      padding: 6px 20px;
  }
  .switch-cover:hover input ~ .checkmark {
    background-color: #ccc;
  }
  .switch-cover input:checked ~ .checkmark {
    background-color: #019d8c;
    color: #fff;
  }
  .switch-cover input:checked ~ .checkmark:after {
    display: block;
  }
  @media(max-width:410px){
    .switch-account{
      padding-right: 0 !important;
      width: 100%;
      padding-bottom: 15px;
    }
    .pf-btn{
      min-width: 85px;
    }
  }
  @media(min-width: 600px) and (max-width:699px){
    .switch-account{
      padding-right: 0 !important;
      width: 100%;
      padding-bottom: 15px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/AccountInformation.vue